(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7455],{

/***/ 76538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _botForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77580);
/* harmony import */ var _createBotStepper_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93034);
/* harmony import */ var _styles_pages_createBotFinal_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(5361);
/* harmony import */ var _styles_pages_createBotFinal_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_createBotFinal_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_pages_createBot_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96633);
/* harmony import */ var _styles_pages_createBot_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_createBot_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14416);
/* harmony import */ var _redux_storeBot_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64362);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49530);
/* harmony import */ var _azure_storage_blob__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60998);
/* harmony import */ var _pages_successModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99696);
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16330);
/* harmony import */ var _redux_global_actions_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39471);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(14890);
/* harmony import */ var _createBotFormss_gdt_data_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97105);

























var index = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), successModal = ref[0], setSuccessModal = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), businessOwnerModal = ref1[0], setBusinessOwnerModal = ref1[1];
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = _utility_endpoints__WEBPACK_IMPORTED_MODULE_8__/* ["default"].blobSasUrlNew */ .ZP.blobSasUrlNew;
    //   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new _azure_storage_blob__WEBPACK_IMPORTED_MODULE_14__/* .BlobServiceClient */ .N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo");
    var firstPage = props.data[0].component.content.field_new_bot_details[0];
    var secondPage = props.data[0].component.content.field_new_bot_details[1];
    var thirdPage = props.data[0].component.content.field_new_bot_details[2];
    var fourthPage = props.data[0].component.content.field_new_bot_details[3];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), renderFirstBot = ref2[0], setRenderFirstBot = ref2[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var isDevEnvironment = _utility_endpoints__WEBPACK_IMPORTED_MODULE_8__/* ["default"].environment */ .ZP.environment === "dev" ? true : false;
    var productData = _createBotFormss_gdt_data_js__WEBPACK_IMPORTED_MODULE_12__/* .product */ .O7;
    var familyData = _createBotFormss_gdt_data_js__WEBPACK_IMPORTED_MODULE_12__/* .family */ .NK;
    var domainData = _createBotFormss_gdt_data_js__WEBPACK_IMPORTED_MODULE_12__/* .domain */ .nw;
    var leadPlatformData = isDevEnvironment ? props.globalData.lead_platform_main_component[3] : props.globalData.lead_platform_main_component[1];
    var areaData = isDevEnvironment ? props.globalData.lead_platform_main_component[4] : props.globalData.lead_platform_main_component[4];
    var subAreaData = isDevEnvironment ? props.globalData.lead_platform_main_component[5] : props.globalData.lead_platform_main_component[3];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var countryData = props.globalData.cluster_main_component[2];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        firstPage.field_bot_form_steps.splice(1, 0, productData);
        firstPage.field_bot_form_steps.splice(1, 0, familyData);
        firstPage.field_bot_form_steps.splice(1, 0, domainData);
        firstPage.field_bot_form_steps.splice(4, 0, subAreaData);
        firstPage.field_bot_form_steps.splice(4, 0, areaData);
        firstPage.field_bot_form_steps.splice(4, 0, leadPlatformData);
        firstPage.field_bot_form_steps.splice(7, 0, countryData);
        firstPage.field_bot_form_steps.splice(7, 0, mcoData);
        firstPage.field_bot_form_steps.splice(7, 0, clusterData);
        setRenderFirstBot(true);
    }, []);
    var useMe = {
        1: false,
        2: false,
        3: false,
        4: false
    };
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        1: true,
        2: false,
        3: false,
        4: false
    }), 2), botPages = ref3[0], setBotPages = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(1), 2), pageNumber = ref4[0], setPageNumber = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), done = ref5[0], setDone = ref5[1];
    var nextBot = function(pageNum) {
        setBotPages((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, useMe), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, pageNum, true)));
        setPageNumber(pageNum);
        window.scrollTo(0, 0);
    };
    var saveInfoToRedux = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(state) {
            var landscapeId, landscape;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                if (state.landscape) {
                    landscapeId = "";
                    landscape = state.landscape;
                    if (landscape == "Global") {
                        landscapeId = "0";
                    }
                    if (landscape == "Fusion") {
                        landscapeId = "1";
                    }
                    if (landscape == "Sirius") {
                        landscapeId = "2";
                    }
                    if (landscape == "Cordillera") {
                        landscapeId = "3";
                    }
                    if (landscape == "U2K2") {
                        landscapeId = "4";
                    }
                    state.landscapeId = landscapeId;
                }
                dispatch((0,_redux_storeBot_actions__WEBPACK_IMPORTED_MODULE_7__/* .saveCurrentBot */ .B1)(state));
                return [
                    2
                ];
            });
        });
        return function saveInfoToRedux(state) {
            return _ref.apply(this, arguments);
        };
    }();
    var allDone = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                // containerClient.deleteBlob(azureFileNames[name]);
                setDone(true);
                return [
                    2
                ];
            });
        //  router.push("/botStore");
        });
        return function allDone() {
            return _ref.apply(this, arguments);
        };
    }();
    // const mmy = {
    //   mCO: "a",
    //   applications: "a",
    //   dateOfStatusChanged: "2021-12-11",
    //   statusComments: "a",
    //   sopReceivedDate: "2021-12-11",
    //   dataClassification: "a",
    //   numberOfRunsInAMonth: "a",
    //   averageTime: "a",
    //   sopDocument: "a",
    //   UserEmail: "David.Raj@unilever.com",
    //   kFA: true,
    //   kfaTransactional: "yes",
    //   kfaInformational: "no",
    //   kfaIUC: "no",
    // };
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), botKiID = ref6[0], setBotKiID = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), Loading = ref7[0], setLoading = ref7[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
        var BotId, _tmp, _tmp1, _i, i, err, countryString, i1, technologyString, i2, mcoString, i3, auth, authCheck, expiryStatus;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    BotId = props.currentBot.botID;
                    if (props.currentBot.landscapeId == 0) {
                        //console.log("landscpae selected ===>1")
                        props.currentBot.landscape = "Global";
                    }
                    if (props.currentBot.landscapeId == 1) {
                        //console.log("landscpae selected ===>2")
                        props.currentBot.landscape = "Fusion";
                    }
                    if (props.currentBot.landscapeId == 2) {
                        //console.log("landscpae selected ===>3")
                        props.currentBot.landscape = "Sirius";
                    }
                    if (props.currentBot.landscapeId == 3) {
                        //console.log("landscpae selected ===>4")
                        props.currentBot.landscape = "Cordillera";
                    }
                    if (props.currentBot.landscapeId == 4) {
                        //console.log("landscpae selected ===>5")
                        props.currentBot.landscape = "U2K2";
                    }
                    if (!(done == true)) return [
                        3,
                        10
                    ];
                    setBotKiID(props.currentBot.botExternalId);
                    if (props.currentBot.landscapeApproval == "Yes") {
                        props.currentBot.landscapeApproval = true;
                    } else {
                        props.currentBot.landscapeApproval = false;
                    }
                    if (props.currentBot.infosecApproval == "Yes") {
                        props.currentBot.infosecApproval = true;
                    } else {
                        props.currentBot.infosecApproval = false;
                    }
                    if (!props.currentBot.uploadDocumentsState) return [
                        3,
                        7
                    ];
                    _tmp = [];
                    for(_tmp1 in props.currentBot.uploadDocumentsState.deleteDocumentsLater)_tmp.push(_tmp1);
                    _i = 0;
                    _state.label = 1;
                case 1:
                    if (!(_i < _tmp.length)) return [
                        3,
                        6
                    ];
                    i = _tmp[_i];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        containerClient.deleteBlob(props.currentBot.uploadDocumentsState.deleteDocumentsLater[i])
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    console.log("error in deleting azure blob", err);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _i++;
                    return [
                        3,
                        1
                    ];
                case 6:
                    delete props.currentBot.uploadDocumentsState;
                    _state.label = 7;
                case 7:
                    countryString = "";
                    for(var i1 in props.currentBot.country){
                        if (i1 < props.currentBot.country.length - 1 && props.currentBot.country.length > 1) {
                            countryString = countryString + props.currentBot.country[i1] + ",";
                        } else {
                            countryString = countryString + props.currentBot.country[i1];
                        }
                    }
                    props.currentBot.country = countryString;
                    technologyString = "";
                    for(var i2 in props.currentBot.technology){
                        if (i2 < props.currentBot.technology.length - 1 && props.currentBot.technology.length > 1) {
                            technologyString = technologyString + props.currentBot.technology[i2] + ",";
                        } else {
                            technologyString = technologyString + props.currentBot.technology[i2];
                        }
                    }
                    props.currentBot.technology = technologyString;
                    mcoString = "";
                    for(var i3 in props.currentBot.mco){
                        if (i3 < props.currentBot.mco.length - 1 && props.currentBot.mco.length > 1) {
                            mcoString = mcoString + props.currentBot.mco[i3] + ",";
                        } else {
                            mcoString = mcoString + props.currentBot.mco[i3];
                        }
                    }
                    props.currentBot.mco = mcoString;
                    auth = JSON.parse(localStorage.getItem("auth")).data;
                    // console.log(auth.accessToken, "accesssssssssss");
                    delete props.currentBot.botID;
                    setLoading(true);
                    return [
                        4,
                        JSON.parse(localStorage.getItem("auth")).data
                    ];
                case 8:
                    authCheck = _state.sent();
                    return [
                        4,
                        props.checkExpiry(authCheck)
                    ];
                case 9:
                    expiryStatus = _state.sent();
                    if (expiryStatus) {
                        axios__WEBPACK_IMPORTED_MODULE_4___default()({
                            method: "put",
                            url: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_8__/* ["default"].baseUrl */ .ZP.baseUrl, "/bot/editBot"),
                            data: {
                                botID: BotId,
                                botUpdateFields: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props.currentBot)
                            },
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            }
                        }).then(function(resp) {
                            if (resp.data.code == 200) {
                                setLoading(false);
                                setSuccessModal(true);
                            } else if (resp.data.code == 403) {
                                setLoading(false);
                                props.sessionTimeOutCheck(true);
                            }
                        });
                    } else {
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                    }
                    _state.label = 10;
                case 10:
                    return [
                        2
                    ];
            }
        });
    }), [
        props.currentBot
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_pages_createBotFinal_module_scss__WEBPACK_IMPORTED_MODULE_20___default().mainContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pages_createBotFinal_module_scss__WEBPACK_IMPORTED_MODULE_20___default().stepperContainer),
                children: [
                    Loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader__WEBPACK_IMPORTED_MODULE_10__["default"], {}) : null,
                    successModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_successModal__WEBPACK_IMPORTED_MODULE_9__["default"], {
                        setSuccessModal: function() {
                            router.push("/botStore");
                        },
                        title: "Edit Bot",
                        parent: "createBot",
                        message: "Bot with BOT ID ".concat(botKiID, " has been updated")
                    }) : null,
                    businessOwnerModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_successModal__WEBPACK_IMPORTED_MODULE_9__["default"], {
                        setSuccessModal: setBusinessOwnerModal,
                        title: "User Access Mapping",
                        message: "Business owner already exist with another user type",
                        // setMessage={setMessage}
                        fail: true
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createBotStepper_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        pageNumber: pageNumber,
                        editBot: true
                    })
                ]
            }),
            botPages[1] == true && renderFirstBot ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_pages_createBot_module_scss__WEBPACK_IMPORTED_MODULE_21___default().botContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_botForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        nextBot: nextBot,
                        data: firstPage.field_bot_form_steps,
                        pageNum: 1,
                        saveInfoToRedux: saveInfoToRedux,
                        savedState: props.currentBot,
                        formType: "editBot",
                        setBusinessOwnerModal: setBusinessOwnerModal
                    })
                })
            }) : null,
            botPages[2] == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_botForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                nextBot: nextBot,
                data: secondPage.field_bot_form_steps,
                pageNum: 2,
                saveInfoToRedux: saveInfoToRedux,
                savedState: props.currentBot,
                formType: "editBot"
            }) : null,
            botPages[3] == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_botForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                nextBot: nextBot,
                data: thirdPage.field_bot_form_steps,
                pageNum: 3,
                saveInfoToRedux: saveInfoToRedux,
                savedState: props.currentBot,
                formType: "editBot"
            }) : null,
            botPages[4] == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_botForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                allDone: allDone,
                nextBot: nextBot,
                data: fourthPage.field_bot_form_steps,
                pageNum: 4,
                saveInfoToRedux: saveInfoToRedux,
                savedState: props.currentBot,
                formType: "editBot"
            }) : null
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        currentBot: state.storeBot.currentBot,
        editedCurrentBot: state.storeBot.editedCurrentBot
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux__WEBPACK_IMPORTED_MODULE_22__/* .bindActionCreators */ .DE)(_redux_global_actions_js__WEBPACK_IMPORTED_MODULE_11__/* .sessionTimeOutCheck */ .Iy, dispatch),
        checkExpiry: (0,redux__WEBPACK_IMPORTED_MODULE_22__/* .bindActionCreators */ .DE)(_redux_global_actions_js__WEBPACK_IMPORTED_MODULE_11__/* .checkExpiry */ .Wr, dispatch)
    };
}
// export default index;
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(index));


/***/ }),

/***/ 77580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ botForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/components/createBotFirst.module.scss
var createBotFirst_module = __webpack_require__(32940);
var createBotFirst_module_default = /*#__PURE__*/__webpack_require__.n(createBotFirst_module);
// EXTERNAL MODULE: ./public/assets/svg/index.jsx + 68 modules
var svg = __webpack_require__(18023);
// EXTERNAL MODULE: ./node_modules/react-datetime/dist/react-datetime.cjs.js
var react_datetime_cjs = __webpack_require__(8660);
var react_datetime_cjs_default = /*#__PURE__*/__webpack_require__.n(react_datetime_cjs);
// EXTERNAL MODULE: ./node_modules/react-datetime/css/react-datetime.css
var react_datetime = __webpack_require__(86060);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./components/listWithoutcheck/index.jsx
var listWithoutcheck = __webpack_require__(45336);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
// EXTERNAL MODULE: ./styles/pages/createSecondPage.module.scss
var createSecondPage_module = __webpack_require__(59111);
var createSecondPage_module_default = /*#__PURE__*/__webpack_require__.n(createSecondPage_module);
// EXTERNAL MODULE: ./styles/components/documentUploader.module.scss
var documentUploader_module = __webpack_require__(38710);
var documentUploader_module_default = /*#__PURE__*/__webpack_require__.n(documentUploader_module);
// EXTERNAL MODULE: ./components/uploadFile/index.jsx
var components_uploadFile = __webpack_require__(67954);
// EXTERNAL MODULE: ./node_modules/@azure/storage-blob/dist-esm/storage-blob/src/BlobServiceClient.js + 206 modules
var BlobServiceClient = __webpack_require__(60998);
// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(74221);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
;// CONCATENATED MODULE: ./components/DocumentUploader/index.jsx














var ModalExample = function(props) {
    var ref = (0,react.useState)({}), uploaded = ref[0], setUploaded = ref[1];
    var ref1 = (0,react.useState)({}), couldNotUpload = ref1[0], setCouldNotUpload = ref1[1];
    var ref2 = (0,react.useState)(null), totalItems = ref2[0], setTotalItems = ref2[1];
    var ref3 = (0,react.useState)(0), uploadedItems = ref3[0], setUploadedItems = ref3[1];
    var ref4 = (0,react.useState)({}), originalFileNames = ref4[0], setOriginalFileNames = ref4[1];
    var ref5 = (0,react.useState)({}), azureFileNames = ref5[0], setAzureFileNames = ref5[1];
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    //   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/botDocuments/".concat(props.documentFolderName));
    // const createContainer = async () => {
    //   try {
    //     // reportStatus(`Creating container "${containerName}"...`);
    //     await containerClient.create();
    //     console.log("done");
    //     // reportStatus(`Done.`);
    //   } catch (error) {
    //     console.log(error);
    //     // reportStatus(error.message);
    //   }
    // };
    // createContainer()
    /**
 *

   
 */ react.useEffect(function() {
        if (props.uploadedDocumentsState != null) {
            {}
            setUploaded(props.uploadedDocumentsState.uploaded);
            setTotalItems(props.uploadedDocumentsState.totalItems);
            setUploadedItems(props.uploadedDocumentsState.uploadedItems);
            setOriginalFileNames(props.uploadedDocumentsState.originalFileNames);
            setAzureFileNames(props.uploadedDocumentsState.azureFileNames);
        }
    }, []);
    var documentAr = [
        {
            title: "SOP",
            value: "sopDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx",
                ".msg",
                ".png",
                ".jpeg",
                ".jpg",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx"
            ]
        },
        {
            title: "PDD",
            value: "pddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD Approval",
            value: "pddApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "SDD",
            value: "sddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "QSG",
            value: "qsgDocument",
            type: [
                ".doc",
                ".docx"
            ]
        },
        {
            title: "ODI",
            value: "odiDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "BRD",
            value: "brdDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Cost Apporval",
            value: "costApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Landscape Approval",
            value: "explicitLandscapeApplicationOwnerApprovalDocument",
            type: ".msg"
        },
        {
            title: "GPM Approval",
            value: "explicitGPMApprovalSupplyChainFinanceDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "GFCF Approval",
            value: "explicitGFCFApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Dev Quality Crendentails Available",
            value: "devQualityCredentialsAvailableDocument",
            type: ".msg"
        },
        {
            title: "Infosec Approval",
            value: "infosecApprovalDocument",
            type: ".msg"
        },
        {
            title: "DA Review Sign Off",
            value: "dAReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "Test Data Development",
            value: "testDataAvailableForDevelopmentDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Request Raised Product Credentials",
            value: "requestRaisedForProductionCredentialsDocument",
            type: ".msg"
        },
        {
            title: "Internal Testing Completed",
            value: "internalTestingCompletedDocument",
            type: ".msg"
        },
        {
            title: "Peer Review Sign Off",
            value: "peerReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "DA Review Second Sign Off",
            value: "daReviewSecondSignOffDocument",
            type: ".msg"
        },
        {
            title: "BP Release Sign Off",
            value: "bpReleaseSignOffFromDaDocument",
            type: ".msg"
        },
        {
            title: "UAT Scripts With Results",
            value: "uatScriptsWithResultsDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Gate Form",
            value: "gateFormDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Peer Review Checklist",
            value: "peerReviewchecklistDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "QA Sign Off",
            value: "qaSignOffDocument",
            type: ".msg"
        },
        {
            title: "Walk Through Video",
            value: "walkthroughVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        },
        {
            title: "KT Video",
            value: "ktVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        }, 
    ];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(documentAr), 2), filteredDocumentAr = ref6[0], setFilteredDocumentAr = ref6[1];
    react.useEffect(function() {
        setTotalItems(documentAr.length);
    }, []);
    // to upload a file
    var ref7 = (0,react.useState)(false), fileUplaodState = ref7[0], setfileUplaodState = ref7[1];
    var ref8 = (0,react.useState)(false), currentlyUploading = ref8[0], setCurrentlyUploading = ref8[1];
    var ref9 = (0,react.useState)({}), presentState = ref9[0], setPresentState = ref9[1];
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, name, title, originalFileName, extension) {
            var counter, i, fileName, blockBlobClient, options, resp, ar, another, finalUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        counter = 0;
                        //console.log(originalFileName, "originalFileNamesfirst", originalFileNames)
                        for(var i in originalFileNames){
                            if (originalFileNames[i].split(".")[0].split("~")[0] + "." + originalFileNames[i].split(".")[originalFileNames[i].split(".").length - 1] == originalFileName) {
                                counter = counter + 1;
                            }
                        }
                        //console.log(counter, "originalFileNameCounter")
                        if (counter > 0) {
                            originalFileName = originalFileName.split(".")[0] + "~" + counter + "." + originalFileName.split(".")[1];
                        }
                        fileName = originalFileName;
                        //console.log(originalFileNames, 'originalFileNames')
                        setCurrentlyUploading(true);
                        setAzureFileNames((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, azureFileNames), (0,_define_property/* default */.Z)({}, name, fileName)));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            },
                            concurrency: 25
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        //console.log("blob upload response----", resp);
                        setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, true)));
                        setUploadedItems(uploadedItems + 1);
                        setOriginalFileNames((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, originalFileNames), (0,_define_property/* default */.Z)({}, name, originalFileName)));
                        ar = resp._response.request.url.split("?");
                        another = ar[0].split("/");
                        finalUrl = another[another.length - 1];
                        // props.sendDocInfo(
                        //   name,
                        //   resp._response.request.url,
                        //   title,
                        //   uploadedItems + 1,
                        //   extension
                        // );
                        setPresentState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, presentState), (0,_define_property/* default */.Z)({}, name, finalUrl)));
                        setCurrentlyUploading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setCurrentlyUploading(false);
                        setCouldNotUpload((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, couldNotUpload), (0,_define_property/* default */.Z)({}, name, true)));
                        setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, false)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(file, name, title, originalFileName, extension) {
            return _ref.apply(this, arguments);
        };
    }();
    // to delete a file
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), deleteDocumentsLater = ref10[0], setDeleteDocumentsLater = ref10[1];
    var deleteThis = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
            var fileName, azureFileNamesVar, previousFileTitle, i, toDelete, azureFileNamesVar1, previousFileTitle1, i1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                fileName = "1" + name;
                //console.log(name, "azureFileName", azureFileNames);
                setPresentState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, presentState), (0,_define_property/* default */.Z)({}, name, "")));
                // if (azureFileNames[name]) {
                if (props.formType == "editBot") {
                    // setDeleteDocumentsLater([
                    //   ...deleteDocumentsLater,
                    //   azureFileNames[name],
                    // ]);
                    //console.log(uploaded, "uploadedBeforeDeleting")
                    setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, false)));
                    setUploadedItems(uploadedItems - 1);
                    azureFileNamesVar = (0,_object_spread/* default */.Z)({}, azureFileNames);
                    delete azureFileNamesVar[name];
                    setAzureFileNames((0,_object_spread/* default */.Z)({}, azureFileNamesVar));
                    previousFileTitle = null;
                    // console.log(uploaded, "xadsda", name)
                    for(var i in uploaded){
                        if (uploaded[i] == true && i != name) {
                            previousFileTitle = i;
                            break;
                        }
                    }
                //  props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
                } else {
                    toDelete = azureFileNames[name];
                    setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, false)));
                    setUploadedItems(uploadedItems - 1);
                    azureFileNamesVar1 = (0,_object_spread/* default */.Z)({}, azureFileNames);
                    delete azureFileNamesVar1[name];
                    setAzureFileNames((0,_object_spread/* default */.Z)({}, azureFileNamesVar1));
                    previousFileTitle1 = null;
                    // console.log(uploaded, "xadsda", name)
                    for(var i1 in uploaded){
                        if (uploaded[i1] == true && i1 != name) {
                            previousFileTitle1 = i1;
                            break;
                        }
                    }
                //   props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
                //   try {
                //  await containerClient.deleteBlob(toDelete);
                // }
                // catch(err) {
                //   console.log(err)
                // }
                }
                return [
                    2
                ];
            });
        // alert("there");
        // }
        });
        return function deleteThis(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchDocuments = function(e) {
        if (e.target.value.length == 0) {
            setFilteredDocumentAr(documentAr);
        } else {
            var options = {
                shouldSort: true,
                keys: [
                    "title",
                    "value",
                    "type"
                ]
            };
            var fuse = new fuse_esm/* default */.Z(documentAr, options);
            // Change the pattern
            var pattern = e.target.value;
            //console.log("pattern  -----", pattern);
            var fuseResult = fuse.search("".concat(pattern));
            var filteredResult = [];
            //console.log("fusee result  ----", fuseResult);
            for(var i in fuseResult){
                filteredResult.push(fuseResult[i].item);
            }
            setFilteredDocumentAr(filteredResult);
        }
    };
    var allDone = function() {
        if (!currentlyUploading) {
            props.sendAllInfoAboutUploadModal(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState);
            props.closeModal();
        }
    };
    // to download a file
    // const downloadThis = async (e) => {
    //   let fileName = "1" + e.target.name;
    //   const blockBlobClient = containerClient.getBlobClient(fileName);
    //   const downloadBlockBlobResponse = await blockBlobClient.download(0);
    //   console.log(downloadBlockBlobResponse);
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (documentUploader_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (documentUploader_module_default()).modalBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (documentUploader_module_default()).content,
                            children: "Document Uploader"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (documentUploader_module_default()).search,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                    name: "searchGrayIcon",
                                    className: (documentUploader_module_default()).searchIcon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search",
                                    onChange: searchDocuments
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (documentUploader_module_default()).formatType,
                            children: "Upload files in the format of .pdf, .doc, .docx, .msg, .png, .jpeg, .jpg, .xls, .xlsx, .ppt, .pptx"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: filteredDocumentAr.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (documentUploader_module_default()).left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    item.title,
                                                    item.title == "SOP" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        children: "*"
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (documentUploader_module_default()).right,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                                                    data: true,
                                                    title: item.title,
                                                    value: item.value,
                                                    fileType: item.value == "walkthroughVideo" || item.value == "ktVideo" ? item.type : [
                                                        ".pdf",
                                                        ".doc",
                                                        ".docx",
                                                        ".msg",
                                                        ".png",
                                                        ".jpeg",
                                                        ".jpg",
                                                        ".xls",
                                                        ".xlsx",
                                                        ".ppt",
                                                        ".pptx"
                                                    ],
                                                    uploadFile: uploadFile,
                                                    uploaded: uploaded[item.value],
                                                    couldNotUpload: couldNotUpload[item.value],
                                                    originalFileName: originalFileNames[item.value],
                                                    type: "createBot",
                                                    specialCase: item.value == "walkthroughVideo" || item.value == "ktVideo" ? true : false,
                                                    currentlyUploading: currentlyUploading
                                                }),
                                                uploaded[item.value] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: function() {
                                                        return deleteThis(item.value);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "deleteicon",
                                                        className: (documentUploader_module_default()).icon
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (documentUploader_module_default()).left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (documentUploader_module_default()).countFilesSelected,
                                children: "".concat(uploadedItems, "/").concat(totalItems, " files selected")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (documentUploader_module_default()).right,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (documentUploader_module_default()).combinedBtn,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (documentUploader_module_default()).rowBtn,
                                        onClick: function() {
                                            return props.closeModal();
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (documentUploader_module_default()).exportListBtn,
                                        onClick: function() {
                                            return allDone();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "uploadicon"
                                            }),
                                            "Upload files"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DocumentUploader = (ModalExample);

;// CONCATENATED MODULE: ./components/uploadDocuments/index.jsx















/* harmony default export */ function uploadDocuments(props) {
    // console.log(props, "FORMTYPE ATTHE UPLOAD")
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), modalShow = ref[0], setModalShow = ref[1];
    var blobSasUrlNew = endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    //   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/botDocuments/".concat(props.savedState.documentFolderName));
    var documentAr = [
        {
            title: "SOP",
            value: "sopDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx",
                ".msg",
                ".png",
                ".jpeg",
                ".jpg",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx"
            ]
        },
        {
            title: "PDD",
            value: "pddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD Approval",
            value: "pddApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "SDD",
            value: "sddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "QSG",
            value: "qsgDocument",
            type: [
                ".doc",
                ".docx"
            ]
        },
        {
            title: "ODI",
            value: "odiDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "BRD",
            value: "brdDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Cost Apporval",
            value: "costApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Landscape Approval",
            value: "explicitLandscapeApplicationOwnerApprovalDocument",
            type: ".msg"
        },
        {
            title: "GPM Approval",
            value: "explicitGPMApprovalSupplyChainFinanceDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "GFCF Approval",
            value: "explicitGFCFApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Dev Quality Crendentails Available",
            value: "devQualityCredentialsAvailableDocument",
            type: ".msg"
        },
        {
            title: "Infosec Approval",
            value: "infosecApprovalDocument",
            type: ".msg"
        },
        {
            title: "DA Review Sign Off",
            value: "dAReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "Test Data Development",
            value: "testDataAvailableForDevelopmentDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Request Raised Product Credentials",
            value: "requestRaisedForProductionCredentialsDocument",
            type: ".msg"
        },
        {
            title: "Internal Testing Completed",
            value: "internalTestingCompletedDocument",
            type: ".msg"
        },
        {
            title: "Peer Review Sign Off",
            value: "peerReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "DA Review Second Sign Off",
            value: "daReviewSecondSignOffDocument",
            type: ".msg"
        },
        {
            title: "BP Release Sign Off",
            value: "bpReleaseSignOffFromDaDocument",
            type: ".msg"
        },
        {
            title: "UAT Scripts With Results",
            value: "uatScriptsWithResultsDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Release Manager Sign Off",
            value: "releaseManagerSignOffDocument",
            type: ".msg"
        },
        {
            title: "Gate Form",
            value: "gateFormDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Peer Review Checklist",
            value: "peerReviewchecklistDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "QA Sign Off",
            value: "qaSignOffDocument",
            type: ".msg"
        },
        {
            title: "Walk Through Video",
            value: "walkthroughVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        },
        {
            title: "KT Video",
            value: "ktVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        }, 
    ];
    var openDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var closeDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(false);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedFileToShow = ref1[0], setUploadedFileToShow = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), totalUploadedItems = ref2[0], setTotalUploadedItems = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedDocumentsState = ref3[0], setUploadedDocumentsState = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), invalid = ref4[0], setInvalid = ref4[1];
    var gotDocInfo = function(name, url, title, uploadedItems, extension) {
        var ar = url.split("?");
        var another = ar[0].split("/");
        var toSend = another[another.length - 1];
        // console.log(title, uploadedItems, "uploaded data of data");
        // console.log(name, "nameat uploaderrr", title)
        //console.log(extension, "extension at 56")
        //  setUploadedFileToShow(title);
        setTotalUploadedItems(uploadedItems);
        props.sendDocInfo(name, toSend, extension);
    };
    // React.useEffect(() => {
    // }, [props.savedState.uploadDocumentsState]);
    var sendAllInfoAboutUploadModal = function(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState) {
        if (uploaded.sopDocument) {
            props.setSopInvalid(false);
        } else {
            props.setSopInvalid(true);
        }
        {}
        //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)
        //console.log(azureFileNames, "azurefiles234latest")
        //console.log(uploadedDocumentsState, "azurefiles234previous")
        var deleteDocumentsLaterToSet = [];
        if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length > 0) {
            deleteDocumentsLaterToSet = (0,_to_consumable_array/* default */.Z)(uploadedDocumentsState.deleteDocumentsLater);
            for(var i in uploadedDocumentsState.azureFileNames){
                if (!(i in azureFileNames)) {
                    deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i]);
                }
            }
        }
        setUploadedDocumentsState({
            uploaded: uploaded,
            totalItems: totalItems,
            uploadedItems: uploadedItems,
            originalFileNames: originalFileNames,
            azureFileNames: (0,_object_spread/* default */.Z)({}, azureFileNames),
            deleteDocumentsLater: (0,_to_consumable_array/* default */.Z)(deleteDocumentsLaterToSet)
        });
        setTotalUploadedItems(uploadedItems);
        props.saveUploadDocumentStateInRedux({
            uploaded: uploaded,
            totalItems: totalItems,
            uploadedItems: uploadedItems,
            originalFileNames: originalFileNames,
            azureFileNames: (0,_object_spread/* default */.Z)({}, azureFileNames),
            deleteDocumentsLater: (0,_to_consumable_array/* default */.Z)(deleteDocumentsLaterToSet)
        }, presentState);
    };
    react.useEffect(function() {
        if (props.savedState.botDemoVideo != "" && props.savedState.botDemoVideo != null) {
            setDemoVideoUploaded(true);
            setDemoVideoOriginalFileNames(props.savedState.botDemoVideo);
        }
        if (props.savedState.uploadDocumentsState) {
            setUploadedDocumentsState(props.savedState.uploadDocumentsState);
            for(var i in props.savedState.uploadDocumentsState.uploaded){
                if (props.savedState.uploadDocumentsState.uploaded[i] == true) {
                    //  setUploadedFileToShow(i)
                    setTotalUploadedItems(props.savedState.uploadDocumentsState.uploadedItems);
                    break;
                }
            }
        } else if (props.formType == "editBot" || props.formType == "createRollout") {
            if (props.savedState) {
                var documentsInfoToBeEdited = [];
                //console.log(props.savedState, "asdsd");
                for(var i1 in documentAr){
                    for(var j in props.savedState){
                        // console.log("j",j)
                        if (j == documentAr[i1].value && //  props.savedState[j].length !== 0 &&
                        props.savedState[j] !== "can be empty" && props.savedState[j] !== "NA" && props.savedState[j] !== "" && props.savedState[j] !== null && props.savedState[j] !== undefined) {
                            documentsInfoToBeEdited.push((0,_define_property/* default */.Z)({}, j, props.savedState[j]));
                        }
                    }
                }
                // console.log(documentsInfoToBeEdited, "documentsInfoToBeEdited");
                var uploaded = {};
                var totalItems = 28;
                // console.log('number of supprting Documents  ---', documentAr.length);
                var uploadedItems = documentsInfoToBeEdited.length;
                var originalFileNames = {};
                var azureFileNames = {};
                documentsInfoToBeEdited.map(function(item, index) {
                    uploaded = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, Object.keys(item)[0], true));
                    originalFileNames = (0,_object_spread/* default */.Z)({}, originalFileNames, item);
                    azureFileNames = (0,_object_spread/* default */.Z)({}, azureFileNames, item);
                });
                // console.log(
                //   uploaded,
                //   "uploaded",
                //   originalFileNames,
                //   "original",
                //   azureFileNames
                // );
                // setUploadedFileToShow(Object.keys(uploaded)[0])
                setTotalUploadedItems(uploadedItems);
                setUploadedDocumentsState({
                    uploaded: uploaded,
                    totalItems: totalItems,
                    uploadedItems: uploadedItems,
                    originalFileNames: originalFileNames,
                    azureFileNames: azureFileNames
                });
            }
        }
    }, []);
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), demoVideoAzureFileName = ref5[0], setDemoVideoAzureFileName = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), demoVideoUploaded = ref6[0], setDemoVideoUploaded = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), demoVideoOriginalFileNames = ref7[0], setDemoVideoOriginalFileNames = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), demoVideoCouldNotUpload = ref8[0], setDemoVideoCouldNotUpload = ref8[1];
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, name, title, originalFileName) {
            var fileName, blockBlobClient, options, resp, demoVideoUrl, ar, another, toSend, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileName = name + Date.now();
                        setDemoVideoAzureFileName(fileName);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        setDemoVideoUploaded(true);
                        setDemoVideoOriginalFileNames(originalFileName);
                        demoVideoUrl = resp._response.request.url;
                        ar = demoVideoUrl.split("?");
                        another = ar[0].split("/");
                        toSend = another[another.length - 1];
                        props.sendDocInfo(name, toSend);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setDemoVideoCouldNotUpload(true);
                        setDemoVideoUploaded(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(file, name, title, originalFileName) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteDemoVideo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setDemoVideoOriginalFileNames("");
                        setDemoVideoUploaded(false);
                        setDemoVideoAzureFileName("");
                        props.deleteDemoVideo();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            containerClient.deleteBlob(demoVideoAzureFileName)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.log(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        // console.log(uploaded, "xadsda", name)
        });
        return function deleteDemoVideo() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mb-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (createSecondPage_module_default()).commmonUploader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (createSecondPage_module_default()).documentUploader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Upload Documents"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (createSecondPage_module_default()).document,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (createSecondPage_module_default()).btnUpload,
                                    onClick: openDocumentModal,
                                    children: "Open Document Uploader"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (createSecondPage_module_default()).text,
                                    children: props.sopInvalid ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "red"
                                        },
                                        children: "Please upload SOP Document"
                                    }) : totalUploadedItems != null && totalUploadedItems !== 0 ? "SOP document ".concat(totalUploadedItems == 1 ? "" : "+ ".concat(totalUploadedItems - 1, " file").concat(totalUploadedItems - 1 == 1 ? "" : "s"), " uploaded") : "Files not uploaded"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (createSecondPage_module_default()).documentUploader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Bot Demo Video"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (createSecondPage_module_default()).document,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createSecondPage_module_default()).demoVideoUpload,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                                        data: true,
                                        title: "Bot Demo Video",
                                        value: "botDemoVideo",
                                        fileType: [
                                            ".mov",
                                            ".avi",
                                            ".mp4"
                                        ],
                                        uploadFile: uploadFile,
                                        uploaded: demoVideoUploaded,
                                        couldNotUpload: demoVideoCouldNotUpload,
                                        originalFileName: demoVideoOriginalFileNames,
                                        type: "createBot"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return deleteDemoVideo();
                                    },
                                    style: {
                                        left: "80%",
                                        cursor: "pointer",
                                        position: "relative"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "deleteicon",
                                        className: (createSecondPage_module_default()).icon
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (createSecondPage_module_default()).uploadContainer,
                    children: modalShow == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentUploader, {
                        closeModal: closeDocumentModal,
                        sendDocInfo: gotDocInfo,
                        sendAllInfoAboutUploadModal: sendAllInfoAboutUploadModal,
                        uploadedDocumentsState: uploadedDocumentsState,
                        formType: props.formType,
                        documentFolderName: props.savedState.documentFolderName
                    }) : null
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./redux/auth/reducer.js
var reducer = __webpack_require__(69365);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/listDropdown/index.jsx
var listDropdown = __webpack_require__(71554);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var Loader = __webpack_require__(16330);
// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./components/shared/skeleton.module.css
var skeleton_module = __webpack_require__(43484);
var skeleton_module_default = /*#__PURE__*/__webpack_require__.n(skeleton_module);
// EXTERNAL MODULE: ./components/shared/config.js
var shared_config = __webpack_require__(60344);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./components/botForm/CreateETForm.jsx + 4 modules
var CreateETForm = __webpack_require__(33272);
;// CONCATENATED MODULE: ./components/botForm/index.jsx
































function index(props) {
    var formatDate = function formatDate() {
        var d = new Date(), month = "" + (d.getMonth() + 1), day = "" + d.getDate(), year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [
            year,
            month,
            day
        ].join("-");
    };
    var validateEmail = function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(email).toLowerCase())) {
            var emailAr = email.split("@");
            if (emailAr.length == 2) {
                if (emailAr[1] == "unilever.com") {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    // return re.test(String(email).toLowerCase());
    };
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var debounce = //for email searching
    function debounce(func, delay) {
        var timeoutId;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(function() {
                func.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
            }, delay);
        };
    };
    var ref, ref1;
    // to convert labels into camelcase
    //console.log(props.data,"savedState");
    var ref2 = (0,react.useState)({}), auth = ref2[0], setAuth = ref2[1];
    var ref3 = (0,react.useState)([]), allBotFields = ref3[0], setAllBotFields = ref3[1];
    var ref4 = (0,react.useState)([]), requiredFieldsArray = ref4[0], setRequiredFieldsArray = ref4[1];
    //console.log(props, "props at create bot");
    // let emailCheck = [];
    var initialStates = {};
    var dropDownsInitialStates = {};
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), emailCheck = ref5[0], setEmailCheck = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), requiredFields = ref6[0], setRequiredFields = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), numberCheck = ref7[0], setNumberCheck = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref8[0], setloading = ref8[1];
    //for emails searching
    var ref9 = (0,react.useState)(""), query = ref9[0], setQuery = ref9[1];
    var ref10 = (0,react.useState)(""), prevEmail = ref10[0], setPrevEmail = ref10[1];
    var ref11 = (0,react.useState)([]), results = ref11[0], setResults = ref11[1];
    var ref12 = (0,react.useState)(false), isSearching = ref12[0], setIsSearching = ref12[1];
    //for cost approver
    var ref13 = (0,react.useState)(""), query2 = ref13[0], setQuery2 = ref13[1];
    var ref14 = (0,react.useState)(""), prevEmail2 = ref14[0], setPrevEmail2 = ref14[1];
    var ref15 = (0,react.useState)([]), results2 = ref15[0], setResults2 = ref15[1];
    var ref16 = (0,react.useState)(false), isSearching2 = ref16[0], setIsSearching2 = ref16[1];
    //for business analyst
    var ref17 = (0,react.useState)(""), baQuery = ref17[0], setBaQuery = ref17[1];
    var ref18 = (0,react.useState)(""), prevBaEmail = ref18[0], setPrevBaEmail = ref18[1];
    var ref19 = (0,react.useState)([]), baResults = ref19[0], setBaResults = ref19[1];
    var ref20 = (0,react.useState)(false), baIsSearching = ref20[0], setBaIsSearching = ref20[1];
    //create ET in Bot form
    var ref21 = (0,react.useState)(""), newlyCreatedET = ref21[0], setNewlyCreatedET = ref21[1];
    react.useEffect(function() {
        // popping some stuff out (dangerous change this while refactoring)
        if (props.pageNum == 2) {
            for(var i in props.data){
                if (i == 8) {
                    props.data.pop();
                }
            }
        }
        setAuth(JSON.parse(localStorage.getItem("auth")).data);
        props.data.map(function(item) {
            //console.log("jjjjjjj",item)
            if (item.field_label == "MCO") {
                item.value = "mco";
            } else if (item.field_label == "Technology") {
                //april 2024
                item.value = "technology";
            } else if (item.field_label == "SOP Received date") {
                item.value = "sopReceivedDate";
            } else if (item.field_label == "PDD Sign off date") {
                item.value = "pddSignOffDate";
            } else if (item.field_label == "BAU date") {
                item.value = "bauDate";
            } else if (item.field_label == "Landscape") {
                item.value = "landscape";
            } else if (item.field_label == "Application") {
                item.value = "applications";
            } else if (item.field_label == "KFAS") {
                item.value = "kfa";
            } else if (item.field_label == "KFAS Type") {
                item.value = "kfaType";
            } else if (item.field_label == "Parent Bot ID") {
                item.value = "parentBotID";
            } else if (item.field_label == "Status") {
                item.value = "status";
            } else {
                item.value = camelize(item.field_label);
            }
        });
        props.data.map(function(item) {
            if (item.field_input_type == "Related Dropdown" && item.field_related_dropdown.length > 0) {
                var fieldOptions = [];
                item.field_dropdown_option_component.map(function(item) {
                    fieldOptions = (0,_to_consumable_array/* default */.Z)(fieldOptions).concat((0,_to_consumable_array/* default */.Z)(item.field_options));
                });
            }
        });
        var emailCheckAr = [];
        var numberCheckAr = [];
        var requiredFields = [];
        props.data.map(function(item) {
            initialStates["kfaTransactional"] = false;
            initialStates["kfaInformational"] = false;
            if (item.field_required == "1") {
                if (item.field_label == "Country") {
                    initialStates[item.value] = [];
                } else if (item.field_label == "Technology") {
                    initialStates["technology"] = [];
                } else if (item.field_label == "KFAS") {
                    initialStates["kfa"] = false;
                    {}
                } else if (item.value == "requestType") {
                    initialStates[item.value] = "New Request";
                } else if (item.value == "createdBy") {
                    // alert("ui")
                    var AuthName = JSON.parse(localStorage.getItem("auth")).data;
                    initialStates[item.value] = AuthName.name ? AuthName.name : AuthName.email;
                } else if (item.value == "dateLogged") {
                    initialStates[item.value] = formatDate();
                } else if (item.value == "supportStatus") {
                    initialStates[item.value] = "PGLS";
                } else {
                // initialStates[item.value] = "";
                }
            }
            if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
                dropDownsInitialStates[item.value] = false;
            }
            if (item.field_required == "1") {
                if (item.value != "dateOfStatusChanged" && item.value != "commentsForStatusChanged" && item.value != "goLiveDate") {
                    requiredFields.push(item.value);
                }
            }
            if (item.field_input_type == "Number") {
                numberCheckAr.push(item.value);
            }
            if (item.field_input_type == "Email") {
                emailCheckAr.push(item.value);
            }
        });
        if (props.savedState.landscapeApproval !== undefined && props.savedState.landscapeApproval !== null) {
            if (props.savedState.landscapeApproval && props.savedState.landscapeApproval !== "No") {
                props.savedState.landscapeApproval = "Yes";
            } else {
                props.savedState.landscapeApproval = "No";
                emailCheckAr = emailCheckAr.filter(function(item) {
                    return item != "landscapeApprover";
                });
                requiredFields = requiredFields.filter(function(item) {
                    return item != "landscapeApprover";
                });
                props.data.map(function(item) {
                    if (item.value == "landscapeApprover") {
                        item.field_required = "0";
                    }
                });
            }
        }
        if (props.savedState.infosecApproval !== undefined && props.savedState.infosecApproval !== null) {
            if (props.savedState.infosecApproval && props.savedState.infosecApproval !== "No") {
                props.savedState.infosecApproval = "Yes";
            } else {
                props.savedState.infosecApproval = "No";
                emailCheckAr = emailCheckAr.filter(function(item) {
                    return item != "infosecApprover";
                });
                requiredFields = requiredFields.filter(function(item) {
                    return item != "infosecApprover";
                });
                props.data.map(function(item) {
                    if (item.value == "infosecApprover") {
                        item.field_required = "0";
                    }
                });
            }
        }
        //console.log(requiredFields, "EMAILtopCheck", emailCheckAr)
        setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFields));
        setAllBotFields(props.data);
        setEmailCheck((0,_to_consumable_array/* default */.Z)(emailCheckAr));
        setNumberCheck((0,_to_consumable_array/* default */.Z)(numberCheckAr));
    }, []);
    // saving bots camalcased label as value
    var ref22 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), relatedDropdowns = ref22[0], setRelatedDropdowns = ref22[1];
    react.useEffect(function() {
        // debugger
        props.data.map(function(item, index) {
            if (item.field_label == "Status") {
                var AuthName = JSON.parse(localStorage.getItem("auth")).data;
                if (AuthName.userType != "qrManager") {
                    item.field_options = item.field_options.filter(function(item) {
                        return item !== "Live";
                    });
                }
            }
        });
        var relatedDropdownToSet = {};
        props.data.map(function(item) {
            if (item.field_input_type == "Related Dropdown") {
                relatedDropdownToSet = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, relatedDropdownToSet), (0,_define_property/* default */.Z)({}, item.value, {
                    allValues: item.field_dropdown_option_component
                }));
            }
        });
        props.data.map(function(item) {
            if (item.field_related_dropdown !== "" && item.field_related_dropdown !== null && item.field_related_dropdown !== undefined) {
                if (!lodash_default().isEmpty(props.savedState)) {
                    //console.log(props.savedState.country, "countryy");
                    //console.log("====>#1",relatedDropdownToSet["mco"])
                    //console.log("====>#11",camelize(item.field_related_dropdown))
                    if (relatedDropdownToSet[camelize(item.field_related_dropdown) == "mCO" ? "mco" : camelize(item.field_related_dropdown)] !== undefined) {
                        //console.log(relatedDropdownToSet,"savedState");
                        var nowValuesArr = relatedDropdownToSet[camelize(item.field_related_dropdown) == "mCO" ? "mco" : camelize(item.field_related_dropdown)].allValues.filter(function(innerItem) {
                            return camelize(item.field_related_dropdown) == "country" ? props.savedState[item.value].includes(innerItem.field_title) : innerItem.field_title == props.savedState[item.value];
                        });
                        //console.log("====>#2",props.savedState[item.value])
                        //console.log("====>#3",nowValuesArr)
                        if (nowValuesArr.length > 0) {
                            var nowValues = [];
                            nowValuesArr.map(function(val) {
                                var _nowValues;
                                (_nowValues = nowValues).push.apply(_nowValues, (0,_to_consumable_array/* default */.Z)(val.field_options));
                            });
                        }
                        //console.log("====>#4",nowValues)
                        //console.log(nowValues,"relatedDropdownToSet");
                        relatedDropdownToSet[camelize(item.field_related_dropdown) == "mCO" ? "mco" : camelize(item.field_related_dropdown)].nowValues = nowValues;
                    }
                }
            }
        });
        //   props.data.map((item, index) => {
        //     if (item.field_related_dropdown !== "" && item.field_related_dropdown !== null && item.field_related_dropdown !== undefined){
        //         console.log(relatedDropdowns, "RELATEDdROPDOWN")
        //     }
        //  })
        setRelatedDropdowns(relatedDropdownToSet);
    }, []);
    var ref23 = (0,_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref23[0], setState = ref23[1];
    var ref24 = (0,_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref24[0], setDropdownState = ref24[1];
    var ref25 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref25[0], setInvalidFlag = ref25[1];
    var ref26 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), sopInvalid = ref26[0], setSopInvalid = ref26[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var inputprops = {
        placeholder: "DD-MM-YYYY",
        readOnly: true
    };
    var botback = function() {
        router_default().push("/botStore");
    };
    var callCreateBoApi = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(boEmail) {
            var auth, authCheck, expiryStatus, botResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl).concat(endpoints/* default.createBO */.ZP.createBO),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    email: boEmail
                                }
                            })
                        ];
                    case 4:
                        botResponse = _state.sent();
                        return [
                            2,
                            botResponse
                        ];
                    case 5:
                        setloading(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        console.log("failed to create bo");
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function callCreateBoApi(boEmail) {
            return _ref.apply(this, arguments);
        };
    }();
    var botSecond = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var boEmail, boResposne, moveAhead, requiredFieldsChange, i, i1, i2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // props.pagenume1  ==
                        //console.log(emailCheck, "emailCHeck")
                        console.log("formState", state);
                        console.log("pageNum", props.pageNum);
                        if (!(props.pageNum == 1 && state.businessOwnerEmailID)) return [
                            3,
                            2
                        ];
                        boEmail = state.businessOwnerEmailID;
                        setloading(true);
                        return [
                            4,
                            callCreateBoApi(boEmail)
                        ];
                    case 1:
                        boResposne = _state.sent();
                        setloading(false);
                        if (boResposne.data.code == 401) {
                            // failure modal true
                            //
                            props.setBusinessOwnerModal(true);
                            return [
                                2
                            ];
                        } else if (boResposne.data.code == 403) {
                            setloading(false);
                            props.sessionTimeOutCheck(true);
                            props.setBusinessOwnerModal(false);
                        } else {
                            props.setBusinessOwnerModal(false);
                        }
                        _state.label = 2;
                    case 2:
                        moveAhead = true;
                        if (state["requestType"] == "New Request") {
                            requiredFieldsChange = requiredFieldsArray.filter(function(item) {
                                return item != "parentBotID";
                            });
                            setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsChange));
                        }
                        //console.log(requiredFieldsArray, "1234");
                        //console.log(state,"1234" )
                        for(var i in requiredFieldsArray){
                            if (typeof state[requiredFieldsArray[i]] == "string") {
                                if (state[requiredFieldsArray[i]].trim() === "" || state[requiredFieldsArray[i]].trim() === undefined || state[requiredFieldsArray[i]].trim() == undefined || state[requiredFieldsArray[i]].trim() == "undefined" || state[requiredFieldsArray[i]].trim() == null) {
                                    moveAhead = false;
                                    break;
                                }
                            } else if (state[requiredFieldsArray[i]] === "" || state[requiredFieldsArray[i]] === undefined || state[requiredFieldsArray[i]] == undefined || state[requiredFieldsArray[i]] == "undefined" || state[requiredFieldsArray[i]] == null) {
                                moveAhead = false;
                                break;
                            }
                        }
                        for(var i1 in numberCheck){
                            if (isNaN(state[numberCheck[i1]])) {
                                moveAhead = false;
                                break;
                            }
                        }
                        //console.log(emailCheck, "emailCHeck")
                        for(var i2 in emailCheck){
                            if (!validateEmail(state[emailCheck[i2]]) && state[emailCheck[i2]]) {
                                //console.log(state[emailCheck[i]] , "baadlater")
                                moveAhead = false;
                            }
                        }
                        if (props.pageNum == 2) {
                            if (state.sopDocument != null && state.sopDocument != undefined) {
                                if (state.sopDocument.length < 1) {
                                    moveAhead = false;
                                    setSopInvalid(true);
                                }
                            } else {
                                setSopInvalid(true);
                                moveAhead = false;
                            }
                        }
                        if (state["kfa"] == true && state["kfaTransactional"] == false && state["kfaInformational"] == false) {
                            moveAhead = false;
                        }
                        if (state["catalogueProducts"] == undefined) {
                            moveAhead = false;
                        }
                        if (moveAhead) {
                            // setInvalidFieldValidate(initialState);
                            //console.log(state, "state is all I need")
                            props.saveInfoToRedux(state, props.pageNum);
                            // dispatch(firstBotCreateAction(state));
                            if (props.pageNum == 4) {
                                props.allDone();
                            } else {
                                props.nextBot(props.pageNum + 1);
                            }
                        // Router.push("/createBotSecondPage");
                        } else {
                            setInvalidFlag(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function botSecond() {
            return _ref.apply(this, arguments);
        };
    }();
    var goBack = function() {
        props.nextBot(props.pageNum - 1);
    };
    //for email searching
    var searchEmails = (0,react.useCallback)(debounce(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(query) {
            var config, ref, ref1, ref2, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!query) return [
                            2,
                            setResults([])
                        ];
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(shared_config/* config.bearerToken */.v.bearerToken)
                            },
                            params: {
                                text: query
                            }
                        };
                        setIsSearching(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/pinterest/getAllUsers"), config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) === "Error while authentication") {
                            react_toastify_esm/* toast.warning */.Am.warning("Session Expired, Please refresh");
                        }
                        if ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : ref2.length) {
                            setResults(res.data.users);
                        }
                        setIsSearching(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsSearching(false);
                        console.error("Error fetching emails:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }(), 500), []);
    //for cost approver
    var searchEmails2 = (0,react.useCallback)(debounce(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(query2) {
            var config, ref, ref1, ref2, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!query2) return [
                            2,
                            setResults2([])
                        ];
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(shared_config/* config.bearerToken */.v.bearerToken)
                            },
                            params: {
                                text: query2
                            }
                        };
                        setIsSearching2(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/pinterest/getAllUsers"), config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) === "Error while authentication") {
                            react_toastify_esm/* toast.warning */.Am.warning("Session Expired, Please refresh");
                        }
                        if ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : ref2.length) {
                            setResults2(res.data.users);
                        }
                        setIsSearching2(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsSearching2(false);
                        console.error("Error fetching emails:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(query2) {
            return _ref.apply(this, arguments);
        };
    }(), 500), []);
    //for business analyst
    var searchBusinessAnalyst = (0,react.useCallback)(debounce(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(baQuery) {
            var config, ref, ref1, ref2, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!baQuery) return [
                            2,
                            setBaResults([])
                        ];
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(shared_config/* config.bearerToken */.v.bearerToken)
                            },
                            params: {
                                text: baQuery
                            }
                        };
                        setBaIsSearching(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/pinterest/getAllUsers"), config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) === "Error while authentication") {
                            react_toastify_esm/* toast.warning */.Am.warning("Session Expired, Please refresh");
                        }
                        if ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : ref2.length) {
                            setBaResults(res.data.users);
                        } else {
                            setBaResults([]);
                        }
                        setBaIsSearching(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setBaIsSearching(false);
                        console.error("Error fetching emails:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(baQuery) {
            return _ref.apply(this, arguments);
        };
    }(), 500), []);
    //for email searching
    var setBusinessOwnerEmail = function(e) {
        setPrevEmail(e.target.value);
        setTimeout(function() {
            setQuery(e.target.value);
        }, 500);
        inputChange(e);
        setResults([]);
    };
    //for cost approver
    var setCostApprover = function(e) {
        setPrevEmail2(e.target.value);
        setTimeout(function() {
            setQuery2(e.target.value);
        }, 500);
        inputChange(e);
        setResults2([]);
    };
    //for business analyst
    var setBusinessAnalyst = function(e) {
        setPrevBaEmail(e.target.value);
        setTimeout(function() {
            setBaQuery(e.target.value);
        }, 500);
        inputChange(e);
        setBaResults([]);
    };
    var inputChange = function(e) {
        //console.log("e.target.name:",e.target.name)
        //console.log("e.target.value:",e.target.value)
        if (e.target.name == "kfa") {
            if (e.target.value == "Yes") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    kfa: true
                }));
            } else {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    kfa: false,
                    kfaInformational: false,
                    kfaTransactional: false
                }));
            }
        } else if (e.target.name == "catalogueProducts") {
            if (e.target.value == "Yes") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    catalogueProducts: true
                }));
            } else {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    catalogueProducts: false
                }));
            }
        } else if (e.target.name == "kfaType") {
            if (e.target.value == "Transactional") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    kfaTransactional: true,
                    kfaInformational: false
                }));
            } else if (e.target.value == "Informational") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    kfaTransactional: false,
                    kfaInformational: true
                }));
            } else {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    kfaTransactional: false,
                    kfaInformational: false
                }));
            }
        } else {
            if (e.target.name == "requestType") {
                if (e.target.value == "New Request") {
                    var requiredFields = requiredFieldsArray;
                    var requiredArToChange = requiredFields.filter(function(item, index) {
                        return item !== "parentBotID";
                    });
                    setRequiredFieldsArray(requiredArToChange);
                } else {
                    var requiredFields1 = requiredFieldsArray;
                    requiredFields1.push("parentBotID");
                    setRequiredFieldsArray(requiredFields1);
                }
            }
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
        }
    };
    var hanldelinputBlur = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var botResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(e.target.name == "parentBotID")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl).concat(endpoints/* default.getBotIdByExtID */.ZP.getBotIdByExtID),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    id: e.target.value
                                }
                            })
                        ];
                    case 1:
                        botResponse = _state.sent();
                        //console.log("botResponse",botResponse.data.data.botID)
                        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, e.target.name, botResponse.data.data.botID)));
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function hanldelinputBlur(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDropDown = function(item) {
        // if (props.formType == "editBot") {
        if (auth.userType != "supportStatus") {
            if (item == "supportStatus") {
                return;
            }
        }
        //}
        setDropdownState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var gotDropDownValue = function(value, dropdownParent, haveRelated, checkbox) {
        //console.log("========>1",value)
        //console.log("========>2",dropdownParent)
        //console.log("========>3", haveRelated)
        //console.log("========>4", checkbox)
        if (value == "None") {
            if (dropdownParent == "country") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, [])));
            } else {
                var newState = state;
                delete newState[dropdownParent];
                setState((0,_object_spread/* default */.Z)({}, newState));
            }
        } else {
            if (dropdownParent == "status") {
                //console.log(value, "valuessToBeAttatchedToForLIFE")
                if (value == "Retired" || value == "On hold" || value == "Rejected") {
                    setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsArray).concat([
                        "commentsForStatusChanged", 
                    ]));
                    var _obj;
                    //  let dateToday = formatDate()
                    // console.log(dateToday)
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "dateOfStatusChanged", formatDate()), (0,_define_property/* default */.Z)(_obj, dropdownParent, value), _obj)));
                //console.log({ ...state, ["dateOfStatusChanged"]: formatDate() });
                } else {
                    if (value == "Live") {
                        setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsArray).concat([
                            "goLiveDate"
                        ]));
                    } else {
                        var requiredFieldsFiltered = requiredFieldsArray.filter(function(item) {
                            return item != "goLiveDate";
                        });
                        setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsFiltered));
                    }
                    var requiredFieldsFiltered1 = requiredFieldsArray.filter(function(item) {
                        return item != "dateOfStatusChanged" && item != "commentsForStatusChanged";
                    });
                    setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsFiltered1));
                    var stateToChange = state;
                    delete stateToChange["dateOfStatusChanged"];
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stateToChange), (0,_define_property/* default */.Z)({}, dropdownParent, value)));
                }
            } else if (dropdownParent == "landscapeApproval") {
                if (value == "Yes") {
                    setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsArray).concat([
                        "landscapeApprover"
                    ]));
                    setEmailCheck((0,_to_consumable_array/* default */.Z)(emailCheck).concat([
                        "landscapeApprover"
                    ]));
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, value)));
                    var updatedFields = allBotFields;
                    updatedFields.map(function(item) {
                        if (item.value == "landscapeApprover") {
                            item.field_required = "1";
                        }
                    });
                    setAllBotFields((0,_to_consumable_array/* default */.Z)(updatedFields));
                } else {
                    var requiredFieldsFiltered2 = requiredFieldsArray.filter(function(item) {
                        return item != "landscapeApprover";
                    });
                    var emailCheckArNow = emailCheck.filter(function(item) {
                        return item != "landscapeApprover";
                    });
                    setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsFiltered2));
                    setEmailCheck((0,_to_consumable_array/* default */.Z)(emailCheckArNow));
                    var _obj1;
                    // let stateToChange = state;
                    // delete stateToChange["landscapeApprover"];
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, dropdownParent, value), (0,_define_property/* default */.Z)(_obj1, "landscapeApprover", ""), _obj1)));
                    var updatedFields1 = allBotFields;
                    updatedFields1.map(function(item) {
                        if (item.value == "landscapeApprover") {
                            //console.log(item, "itemmm");
                            item.field_required = "0";
                        }
                    });
                    setAllBotFields((0,_to_consumable_array/* default */.Z)(updatedFields1));
                }
            } else if (dropdownParent == "infosecApproval") {
                if (value == "Yes") {
                    setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsArray).concat([
                        "infosecApprover"
                    ]));
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, value)));
                    setEmailCheck((0,_to_consumable_array/* default */.Z)(emailCheck).concat([
                        "infosecApprover"
                    ]));
                    var updatedFields2 = allBotFields;
                    updatedFields2.map(function(item) {
                        if (item.value == "infosecApprover") {
                            item.field_required = "1";
                        }
                    });
                    setAllBotFields((0,_to_consumable_array/* default */.Z)(updatedFields2));
                } else {
                    var requiredFieldsFiltered3 = requiredFieldsArray.filter(function(item) {
                        return item != "infosecApprover";
                    });
                    var emailCheckArNow1 = emailCheck.filter(function(item) {
                        return item != "infosecApprover";
                    });
                    setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsFiltered3));
                    setEmailCheck((0,_to_consumable_array/* default */.Z)(emailCheckArNow1));
                    var _obj2;
                    // let stateToChange = state;
                    // delete stateToChange["infosecApprover"];
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, dropdownParent, value), (0,_define_property/* default */.Z)(_obj2, "infosecApprover", ""), _obj2)));
                    var updatedFields3 = allBotFields;
                    updatedFields3.map(function(item) {
                        if (item.value == "infosecApprover") {
                            item.field_required = "0";
                        }
                    });
                    setAllBotFields((0,_to_consumable_array/* default */.Z)(updatedFields3));
                }
            } else {
                if (haveRelated != null && haveRelated.length > 0) {
                    var newState1 = state;
                    delete newState1[haveRelated];
                    var myArr = props.data.filter(function(item) {
                        return item.value == haveRelated;
                    });
                    if (myArr.length > 0) {
                        if (myArr[0].field_related_dropdown) {
                            var emptyNowValues = camelize(myArr[0].field_related_dropdown);
                        }
                    }
                    props.data.map(function(item, index) {
                        if (item.value == haveRelated) {
                            if (camelize(item.field_related_dropdown) != null && camelize(item.field_related_dropdown).length > 0) {
                                //  let newerState = state
                                if (camelize(item.field_related_dropdown) == "country") {
                                    newState1["country"] = [];
                                    newState1["mco"] = [];
                                } else {
                                    delete newState1[camelize(item.field_related_dropdown)];
                                }
                            }
                        }
                    });
                    setState(newState1);
                    //console.log(relatedDropdowns, "related Ka Khel");
                    var selectedRelatedDropdown = relatedDropdowns;
                    // selectedRelatedDropdown[haveRelated].nowValues =
                    // selectedRelatedDropdown[haveRelated].allValues.filter(
                    //   (item) => item.field_title == value
                    // )[0].field_options;
                    selectedRelatedDropdown[haveRelated].nowValues = "";
                    if (Array.isArray(value)) {
                        var _arr;
                        console.log("running first if");
                        var arr = [];
                        selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                            return value.includes(item.field_title);
                        }).map(function(va, index) {
                            return (_arr = arr).push.apply(_arr, (0,_to_consumable_array/* default */.Z)(va.field_options));
                        });
                        selectedRelatedDropdown[haveRelated].nowValues = arr;
                    } else {
                        //ET Profile
                        if (dropdownParent === "technology" && value !== "ET") {
                            console.log("running do nothing for direct check");
                            if (state["technology"].includes("ET")) {
                                console.log("fetch dropdown values of ET Profile");
                                selectedRelatedDropdown[haveRelated].nowValues = selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                                    return item.field_title == "ET";
                                })[0].field_options;
                            }
                        } else {
                            console.log("running else one");
                            selectedRelatedDropdown[haveRelated].nowValues = selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                                return item.field_title == value;
                            })[0].field_options;
                        }
                    }
                    if (emptyNowValues) {
                        delete selectedRelatedDropdown[emptyNowValues].nowValues;
                    }
                    setRelatedDropdowns((0,_object_spread/* default */.Z)({}, selectedRelatedDropdown));
                }
                if (dropdownParent == "country") {
                    var repeatedFlag = false;
                    // alert(value+"==="+JSON.stringify(state[dropdownParent]))
                    for(var i in state[dropdownParent]){
                        if (state[dropdownParent][i] == value) {
                            repeatedFlag = true;
                            break;
                        }
                    }
                    if (!repeatedFlag) {
                        // console.log("state[dropdownParent]",state[dropdownParent])
                        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, (0,_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                            value
                        ]))));
                    }
                // setState({ ...state, [dropdownParent]: [value] });
                } else if (dropdownParent == "mco") {
                    var repeatedFlag1 = false;
                    for(var i1 in state[dropdownParent]){
                        if (Array.isArray(value)) {
                            if (state[dropdownParent][i1] == value[value.length - 1]) {
                                repeatedFlag1 = true;
                                break;
                            }
                        } else {
                            if (state[dropdownParent][i1] == value) {
                                repeatedFlag1 = true;
                                break;
                            }
                        }
                    }
                    if (!repeatedFlag1) {
                        if (Array.isArray(value)) {
                            var _obj3;
                            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, dropdownParent, (0,_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                                value[value.length - 1]
                            ])), (0,_define_property/* default */.Z)(_obj3, "country", []), _obj3)));
                        } else {
                            var _obj4;
                            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, dropdownParent, (0,_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                                value
                            ])), (0,_define_property/* default */.Z)(_obj4, "country", []), _obj4)));
                        }
                    }
                // setState({ ...state, [dropdownParent]: [value] });
                } else if (dropdownParent == "technology") {
                    //april 2024
                    var repeatedFlag2 = false;
                    for(var i2 in state[dropdownParent]){
                        if (state[dropdownParent][i2] == value) {
                            repeatedFlag2 = true;
                            break;
                        }
                    }
                    if (!repeatedFlag2) {
                        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, (0,_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                            value
                        ]))));
                    }
                } else {
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, value)));
                }
            }
        }
        if (!checkbox) {
            setDropdownState(dropDownsInitialStates);
        }
    };
    react.useEffect(function() {
    //console.log(state.mco, "========>stateisAllineed")
    }, [
        state
    ]);
    var handleDate = function(date, parent) {
        if (typeof date == "object") {
            var bigDate = date._d;
            var dd = String(bigDate.getDate()).padStart(2, "0");
            var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = bigDate.getFullYear();
            var myDate = yyyy + "-" + mm + "-" + dd;
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, parent, myDate)));
        } else {
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, parent, date._d)));
        }
    };
    var convertToDDMMYYYY = function(date, Z) {
        var year = date.slice(0, 4);
        var month = date.slice(5, 7);
        var day = date.slice(8, 10);
        var newDate = day + "-" + month + "-" + year;
        return newDate;
    };
    react.useEffect(function() {
        //console.log("props.savedState",props.savedState)
        if (props.savedState) {
            if (props.savedState.country) {
                if (typeof props.savedState.country == "string") {
                    props.savedState.country = props.savedState.country.split(",");
                    if (props.savedState.country[props.savedState.country.length - 1] == "") {
                        props.savedState.country.pop();
                    }
                }
            }
            if (props.savedState.mco) {
                if (typeof props.savedState.mco == "string") {
                    props.savedState.mco = props.savedState.mco.split(",");
                    if (props.savedState.mco[props.savedState.mco.length - 1] == "") {
                        props.savedState.mco.pop();
                    }
                }
            }
            //technology 4/12/24
            if (props.savedState.technology) {
                if (typeof props.savedState.technology == "string") {
                    props.savedState.technology = props.savedState.technology.split(",");
                    if (props.savedState.technology[props.savedState.technology.length - 1] == "") {
                        props.savedState.technology.pop();
                    }
                }
            }
            // props.savedState.parentBotID = props.savedState.botID;
            // console.log(emailCheckNowAr, "EMAILTopCHECK", requiredArToChangeNow)
            // setEmailCheck([...emailCheckNowAr])
            // setRequiredFields([...requiredArToChangeNow])
            setState((0,_object_spread/* default */.Z)({}, state, props.savedState));
        }
    }, []);
    var gotDocInfo = function(name, url, extension) {
        //console.log(url, "tera dhiyaan kidhar hai, url idhar hai", extension);
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, name, url)));
    };
    var gotUploadDocumentsState = function(uploadDocumentsState, presentState) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, presentState), {
            uploadDocumentsState: uploadDocumentsState
        }));
    };
    var deleteDemoVideo = function() {
        state.botDemoVideo = "";
    };
    var removeCheckedValue = function(option, dropdownParent, haveRelated) {
        if (dropdownParent == "mco") {
            var _arr;
            //console.log("removedChecked Value",option,dropdownParent,haveRelated)
            var changedCheckBoxAr = state[dropdownParent].filter(function(item) {
                return item != option;
            });
            var selectedRelatedDropdown = relatedDropdowns;
            var arr = [];
            selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                return changedCheckBoxAr.includes(item.field_title);
            //  item.field_title == value
            }).map(function(va, index) {
                return (_arr = arr).push.apply(_arr, (0,_to_consumable_array/* default */.Z)(va.field_options));
            });
            selectedRelatedDropdown[haveRelated].nowValues = arr;
            setRelatedDropdowns((0,_object_spread/* default */.Z)({}, selectedRelatedDropdown));
            var _obj;
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj = {}, (0,_define_property/* default */.Z)(_obj, dropdownParent, (0,_to_consumable_array/* default */.Z)(changedCheckBoxAr)), (0,_define_property/* default */.Z)(_obj, "country", []), _obj)));
        } else {
            var changedCheckBoxAr1 = state[dropdownParent].filter(function(item) {
                return item != option;
            });
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, dropdownParent, (0,_to_consumable_array/* default */.Z)(changedCheckBoxAr1))));
        //console.log("removedChecked Value 1",changedCheckBoxAr)
        }
    };
    //create ET in Bot form
    var closeETForm = function() {
        setState(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                eTProfile: "",
                technology: []
            });
        });
    };
    //for email searching
    var businessOwnerEmailID = state.businessOwnerEmailID;
    (0,react.useEffect)(function() {
        if (props.formType === "editBot") {
            setQuery(state.businessOwnerEmailID);
        }
    }, [
        businessOwnerEmailID
    ]);
    (0,react.useEffect)(function() {
        if (props.pageNum == 1) {
            if (prevEmail !== query) {
                searchEmails(query);
            }
            if (query === "" && props.formType !== "createRollout" && props.formType !== "editBot") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    businessOwnerEmailID: ""
                }));
            }
        }
    }, [
        query,
        searchEmails
    ]);
    //for cost approver start
    var costApprover = state.costApprover;
    (0,react.useEffect)(function() {
        if (props.formType === "editBot") {
            setQuery2(state.costApprover);
        }
    }, [
        costApprover
    ]);
    //for business analyst start
    var businessAnalyst = state.businessAnalyst;
    (0,react.useEffect)(function() {
        if (props.formType === "editBot") {
            setBaQuery(state.businessAnalyst);
        }
    }, [
        businessAnalyst
    ]);
    (0,react.useEffect)(function() {
        if (props.pageNum == 1) {
            if (prevEmail2 !== query2) {
                searchEmails2(query2);
            }
            if (query2 === "" && props.formType !== "createRollout" && props.formType !== "editBot") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    costApprover: ""
                }));
            }
        }
    }, [
        query2,
        searchEmails2
    ]);
    //for cost approver end
    (0,react.useEffect)(function() {
        if (props.pageNum == 1) {
            if (prevBaEmail !== baQuery) {
                searchBusinessAnalyst(baQuery);
            }
            if (baQuery === "" && props.formType !== "createRollout" && props.formType !== "editBot") {
                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    businessAnalyst: ""
                }));
            }
        }
    }, [
        baQuery,
        searchBusinessAnalyst
    ]);
    //create ET in Bot form
    var technology = state.technology;
    (0,react.useEffect)(function() {
        //if no ET selected in tech remove eTProfile
        if (!(technology === null || technology === void 0 ? void 0 : technology.includes("ET"))) {
            var requiredFieldsChange = requiredFieldsArray.filter(function(item) {
                return item !== "eTProfile";
            });
            setRequiredFieldsArray((0,_to_consumable_array/* default */.Z)(requiredFieldsChange));
        }
    }, [
        technology
    ]);
    //new et addition
    (0,react.useEffect)(function() {
        if (newlyCreatedET) {
            setState(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    eTProfile: newlyCreatedET
                });
            });
            var getIndexOfETProfile = props.data.findIndex(function(item) {
                return item.field_form_field_title === "ET Profile";
            });
            if (getIndexOfETProfile === -1) {
                return;
            }
            var existingData = props.data[getIndexOfETProfile].field_dropdown_option_component[0].field_options;
            var newData = [
                newlyCreatedET
            ].concat((0,_to_consumable_array/* default */.Z)(existingData));
            props.data[getIndexOfETProfile].field_dropdown_option_component[0].field_options = newData;
            setNewlyCreatedET("");
        }
    }, [
        newlyCreatedET
    ]);
    (0,react.useEffect)(function() {
        var getIndexOfETProfile = props.data.findIndex(function(item) {
            return item.field_form_field_title === "ET Profile";
        });
        console.log("getIndexOfETProfile", getIndexOfETProfile);
        if (getIndexOfETProfile === -1) {
            return;
        }
        var existingData = props.data[getIndexOfETProfile].field_dropdown_option_component[0].field_options;
        var getNewETs = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var auth, config, res, ETs, newData, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (true) {
                                auth = JSON.parse(localStorage.getItem("auth")).data;
                            }
                            config = {
                                headers: {
                                    Authorization: auth.accessToken
                                }
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                axios_default().post("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/get-ets"), {
                                    exceptETs: existingData
                                }, config)
                            ];
                        case 2:
                            res = _state.sent();
                            ETs = res.data.data.map(function(item) {
                                return item.employeeTwinName;
                            });
                            if (Array.isArray(ETs)) {
                                newData = (0,_to_consumable_array/* default */.Z)(ETs).concat((0,_to_consumable_array/* default */.Z)(existingData));
                                newData.unshift("Create new ET Profile");
                                console.log("newData", newData);
                                props.data[getIndexOfETProfile].field_dropdown_option_component[0].field_options = newData;
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log("Error", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getNewETs() {
                return _ref.apply(this, arguments);
            };
        }();
        getNewETs();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (createBotFirst_module_default()).mainContain,
        children: [
            (state === null || state === void 0 ? void 0 : state.eTProfile) === "Create new ET Profile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateETForm/* default */.Z, {
                closeETForm: closeETForm,
                globalData: props.globalData,
                formDataBots: props.data,
                setNewlyCreatedET: setNewlyCreatedET,
                state: {
                    leadPlatform: state.leadPlatform,
                    area: state.area,
                    subArea: state.subArea,
                    cluster: state.cluster,
                    mco: (ref = state.mco) === null || ref === void 0 ? void 0 : ref.join(","),
                    country: (ref1 = state.country) === null || ref1 === void 0 ? void 0 : ref1.join(",")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((createBotFirst_module_default()).first_container, " container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: allBotFields.map(function(item, index) {
                        if (item.field_input_type == "Radio") {
                            if (item.field_label == "KFAS Type") {
                                if (state.kfa == true) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : "col-lg-4 col-md-6", " col-12"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((createBotFirst_module_default()).formGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                            onChange: inputChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createBotFirst_module_default()).mainLabel,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                item.field_form_field_title,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                    className: (createBotFirst_module_default()).mandatoryField,
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        invalidFlag ? state["kfa"] == true && state["kfaTransactional"] == false && state["kfaInformational"] == false ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createBotFirst_module_default()).errorMessage,
                                                            children: "Please choose a KFAS type"
                                                        }) : null : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (createBotFirst_module_default()).inputGroupWrapper,
                                                    children: item.field_options.map(function(radioItem, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (createBotFirst_module_default()).radioWrapper,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (createBotFirst_module_default()).subLabel,
                                                                    children: radioItem
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "radio",
                                                                    className: (createBotFirst_module_default()).radioBox,
                                                                    value: radioItem,
                                                                    name: item.value,
                                                                    checked: state["kfaTransactional"] == true && radioItem == "Transactional" || state["kfaInformational"] == true && radioItem == "Informational" ? true : false
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (createBotFirst_module_default()).radioCheckmark
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        })
                                    });
                                } else {
                                    return null;
                                }
                            } else if (item.field_label == "KFAS") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? "col-12" : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).formGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        onChange: inputChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createBotFirst_module_default()).mainLabel,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        item.field_form_field_title,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createBotFirst_module_default()).mandatoryField,
                                                            children: "*"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (createBotFirst_module_default()).inputGroupWrapper,
                                                children: item.field_options.map(function(radioItem, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (createBotFirst_module_default()).radioWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createBotFirst_module_default()).subLabel,
                                                                children: radioItem
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "radio",
                                                                className: (createBotFirst_module_default()).radioBox,
                                                                value: radioItem,
                                                                name: item.value,
                                                                checked: state[item.value] == radioItem ? true : state[item.value] == false && radioItem == "No" || state[item.value] == true && radioItem == "Yes" ? true : false
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createBotFirst_module_default()).radioCheckmark
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                });
                            } else if (item.field_label == "Catalogue Products") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? "col-12" : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).formGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        onChange: inputChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createBotFirst_module_default()).mainLabel,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item.field_form_field_title,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (createBotFirst_module_default()).mandatoryField,
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    invalidFlag ? state["catalogueProducts"] == undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Please choose a Catalogue Products"
                                                    }) : null : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (createBotFirst_module_default()).inputGroupWrapper,
                                                children: item.field_options.map(function(radioItem, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (createBotFirst_module_default()).radioWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createBotFirst_module_default()).subLabel,
                                                                children: radioItem
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "radio",
                                                                className: (createBotFirst_module_default()).radioBox,
                                                                value: radioItem,
                                                                name: item.value,
                                                                checked: state[item.value] == radioItem ? true : state[item.value] == false && radioItem == "No" || state[item.value] == true && radioItem == "Yes" ? true : false
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createBotFirst_module_default()).radioCheckmark
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                });
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? "col-12" : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).formGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        onChange: inputChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createBotFirst_module_default()).mainLabel,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        item.field_form_field_title,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createBotFirst_module_default()).mandatoryField,
                                                            children: "*"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (createBotFirst_module_default()).inputGroupWrapper,
                                                children: item.field_options.filter(function(radioItem, index) {
                                                    //console.log("bhai idhar dekhle",radioItem)
                                                    return props.formType == "createRollout" ? radioItem == "Roll Out" : props.formType == "editBot" ? radioItem : radioItem !== "Roll Out";
                                                }).map(function(radioItem, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: radioItem !== "Change Request" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (createBotFirst_module_default()).radioWrapper,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (createBotFirst_module_default()).subLabel,
                                                                    children: radioItem
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "radio",
                                                                    className: (createBotFirst_module_default()).radioBox,
                                                                    value: radioItem,
                                                                    name: item.value,
                                                                    disabled: props.formType == "editBot" ? props.savedState.requestType == "Roll Out" ? true : radioItem == "Roll Out" : false,
                                                                    checked: state[item.value] == radioItem ? true : state[item.value] == false && radioItem == "No" || state[item.value] == true && radioItem == "Yes" ? true : props.formType == "createRollout" ? true : false
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (createBotFirst_module_default()).radioCheckmark
                                                                })
                                                            ]
                                                        }, index)
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                });
                            }
                        } else if (item.field_input_type == "Plain Text" || item.field_input_type == "Number" || item.field_input_type == "Email") {
                            if (item.field_label == "Business Analyst") {
                                // for business analyst
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? null : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).inputGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item.field_form_field_title,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Incorrect Format"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "".concat((createBotFirst_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (createBotFirst_module_default()).errorBorder : null : null),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: item.field_title,
                                                    id: "businessAnalyst",
                                                    onChange: function(e) {
                                                        return setBaQuery(e.target.value);
                                                    },
                                                    value: baQuery
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute z-50 left-0 top-[85px] max-h-[150px] shadow-md overflow-y-auto bg-white w-full flex flex-col",
                                                children: baIsSearching ? [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ].map(function(item, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full h-6 ".concat((skeleton_module_default()).skeleton_box)
                                                    }, idx);
                                                }) : baResults.map(function(data, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: function() {
                                                            return setBusinessAnalyst({
                                                                target: {
                                                                    name: "businessAnalyst",
                                                                    value: data.email
                                                                }
                                                            });
                                                        },
                                                        className: "p-3 hover:bg-[rgba(0,0,0,0.1)] cursor-pointer",
                                                        children: data.email
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    })
                                });
                            } else if (item.field_label == "Cost Approver") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? null : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).inputGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item.field_form_field_title,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Incorrect Format"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "".concat((createBotFirst_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (createBotFirst_module_default()).errorBorder : null : null),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: item.field_title,
                                                    id: "costApprover",
                                                    onChange: function(e) {
                                                        return setQuery2(e.target.value);
                                                    },
                                                    value: query2
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute z-50 left-0 top-[85px] max-h-[150px] shadow-md overflow-y-auto bg-white w-full flex flex-col",
                                                children: isSearching2 ? [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ].map(function(item, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full h-6 ".concat((skeleton_module_default()).skeleton_box)
                                                    }, idx);
                                                }) : results2.map(function(data, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: function() {
                                                            return setCostApprover({
                                                                target: {
                                                                    name: "costApprover",
                                                                    value: data.email
                                                                }
                                                            });
                                                        },
                                                        className: "p-3 hover:bg-[rgba(0,0,0,0.1)] cursor-pointer",
                                                        children: data.email
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    })
                                });
                            //for email searching
                            } else if (item.field_label == "Business Owner Email ID") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? null : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).inputGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item.field_form_field_title,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Incorrect Format"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "".concat((createBotFirst_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (createBotFirst_module_default()).errorBorder : null : null),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: item.field_title,
                                                    id: "businessOwner",
                                                    onChange: function(e) {
                                                        return setQuery(e.target.value);
                                                    },
                                                    value: query
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute z-50 left-0 top-[85px] max-h-[150px] shadow-md overflow-y-auto bg-white w-full flex flex-col",
                                                children: isSearching ? [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ].map(function(item, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full h-6 ".concat((skeleton_module_default()).skeleton_box)
                                                    }, idx);
                                                }) : results.map(function(data, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: function() {
                                                            return setBusinessOwnerEmail({
                                                                target: {
                                                                    name: "businessOwnerEmailID",
                                                                    value: data.email
                                                                }
                                                            });
                                                        },
                                                        className: "p-3 hover:bg-[rgba(0,0,0,0.1)] cursor-pointer",
                                                        children: data.email
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    })
                                });
                            } else if (item.field_label == "Parent Bot ID") {
                                if (state.requestType != "New Request") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? null : "col-lg-4 col-md-6", " col-12"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((createBotFirst_module_default()).inputGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                item.field_form_field_title,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createBotFirst_module_default()).errorMessage,
                                                            children: "Incorrect Format"
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "".concat((createBotFirst_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (createBotFirst_module_default()).errorBorder : null : null),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: item.field_title,
                                                        name: item.value,
                                                        disabled: props.formType == "createRollout" ? true : false,
                                                        onChange: props.formType !== "createRollout" && inputChange,
                                                        onBlur: props.formType !== "createRollout" && hanldelinputBlur,
                                                        defaultValue: props.savedState.botExternalId
                                                    })
                                                })
                                            ]
                                        })
                                    });
                                } else {
                                    return null;
                                }
                            } else if (item.value == "commentsForStatusChanged" && state.status !== "Rejected" && state.status !== "On hold" && state.status !== "Retired") {
                                return null;
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : item.field_column_size == "Extra Large" ? null : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).inputGroup, " ").concat(item.field_column_size == "Large" ? (createBotFirst_module_default()).fullWidth : item.field_column_size == "Extra Large" ? (createBotFirst_module_default()).maxWidth : null),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item.field_form_field_title,
                                                            item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                children: "*"
                                                            }) : null
                                                        ]
                                                    }),
                                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: item.field_message_ip_error_message
                                                    }) : item.field_input_type == "Email" && !validateEmail(state[item.value]) && emailCheck.includes(item.value) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Enter a valid unilever email"
                                                    }) : item.field_input_type == "Number" && isNaN(state[item.value]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Enter a valid number"
                                                    }) : null : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "".concat((createBotFirst_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" || item.field_input_type == "Email" && !validateEmail(state[item.value]) && emailCheck.includes(item.value) || item.field_input_type == "Number" && isNaN(state[item.value]) ? (createBotFirst_module_default()).errorBorder : null : null),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: item.value == "createdBy" ? "" : item.field_title,
                                                    name: item.value,
                                                    onChange: inputChange,
                                                    value: item.value !== "createdBy" ? state[item.value] ? state[item.value] : "" : props.formType == "editBot" ? state[item.value] : auth.name ? auth.name : auth.email,
                                                    disabled: item.value == "createdBy" || item.value == "landscapeApprover" && state.landscapeApproval == "No" || item.value == "infosecApprover" && state.infosecApproval == "No" ? true : false
                                                })
                                            }),
                                            item.value == "processID" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (createBotFirst_module_default()).fieldFormat,
                                                children: "e.g. UL<BP/AA/UI> <3 letter Lead Platform> <3 letter sub area> <1 letter SAP landscape C/S/F/U> <3 digit ID> <Process description> </Process>"
                                            }) : null
                                        ]
                                    })
                                });
                            }
                        } else if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : "col-lg-4 col-md-6", " col-12"),
                                style: {
                                    display: item.field_label === "ET Profile" && !state["technology"].includes("ET") ? "none" : "block"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: item.field_label === "ET Profile" && !state["technology"].includes("ET") ? "none" : "block"
                                    },
                                    className: (createBotFirst_module_default()).inputGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        item.field_form_field_title,
                                                        item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            children: "*"
                                                        }) : null
                                                    ]
                                                }),
                                                invalidFlag ? (state[item.value] == "" || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (createBotFirst_module_default()).errorMessage,
                                                    children: item.field_message_ip_error_message
                                                }) : null : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            className: "".concat((createBotFirst_module_default()).input, " ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (createBotFirst_module_default()).errorBorder : null : null),
                                            onClick: function() {
                                                // ((props.formType == "editBot") && (item.field_label == "Landscape"))?void(0):
                                                handleDropDown(item.value);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (createBotFirst_module_default()).left,
                                                    children: state[item.value] == null || state[item.value] == "undefined" || state[item.value] === "" || state[item.value] === undefined ? item.field_input : item.field_label == "Country" ? state.country != undefined && state.country != null ? state.country.length == 0 ? item.field_input : "".concat(state.country.length, " items selected") : item.field_input : item.field_label == "MCO" ? state.mco != undefined && state.mco != null ? state.mco.length == 0 ? item.field_input : "".concat(state.mco.length, " items selected") : item.field_input : item.field_label == "Technology" ? state.technology != undefined && state.technology != null ? state.technology.length == 0 ? item.field_input : "".concat(state.technology.length, " items selected") : item.field_input : state[item.value]
                                                }),
                                                auth.userType != "supportStatus" ? item.field_label != "Support Status" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (createBotFirst_module_default()).right,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "chevron",
                                                        className: (createBotFirst_module_default()).chevron
                                                    })
                                                }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (createBotFirst_module_default()).right,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "chevron",
                                                        className: (createBotFirst_module_default()).chevron
                                                    })
                                                })
                                            ]
                                        }),
                                        dropDownState[item.value] == true ? item.field_label == "Country" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listDropdown/* default */.Z, {
                                            values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                            (0,_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                                "No parent Selected"
                                            ] : // "None",
                                            (0,_to_consumable_array/* default */.Z)(item.field_options),
                                            removeCheckedValue: removeCheckedValue,
                                            presentState: state.country,
                                            getDropdownValue: gotDropDownValue,
                                            haveRelated: item.field_related_dropdown == "MCO" ? "mco" : camelize(item.field_related_dropdown),
                                            dropdownParent: item.value
                                        }) : item.field_label == "MCO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listDropdown/* default */.Z, {
                                            values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                            (0,_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                                "No parent Selected"
                                            ] : // "None",
                                            (0,_to_consumable_array/* default */.Z)(item.field_options),
                                            removeCheckedValue: removeCheckedValue,
                                            presentState: state.mco,
                                            getDropdownValue: gotDropDownValue,
                                            haveRelated: camelize(item.field_related_dropdown),
                                            dropdownParent: item.value
                                        }) : item.field_label == "Technology" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listDropdown/* default */.Z, {
                                            values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                            (0,_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                                "No parent Selected"
                                            ] : // "None",
                                            (0,_to_consumable_array/* default */.Z)(item.field_options),
                                            removeCheckedValue: removeCheckedValue,
                                            presentState: state.technology,
                                            getDropdownValue: gotDropDownValue,
                                            haveRelated: camelize(item.field_related_dropdown),
                                            dropdownParent: item.value
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                            dropdownParent: item.value,
                                            values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                            (0,_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                                "No parent Selected"
                                            ] : // "None",
                                            (0,_to_consumable_array/* default */.Z)(item.field_options),
                                            getDropdownValue: gotDropDownValue,
                                            // haveRelated={"mco"}
                                            haveRelated: item.field_related_dropdown == "MCO" ? "mco" : camelize(item.field_related_dropdown),
                                            closeAllDropdowns: function() {
                                                setDropdownState(dropDownsInitialStates);
                                            }
                                        }) : null
                                    ]
                                })
                            });
                        } else if (item.field_input_type == "Date") {
                            if (item.value == "dateOfStatusChanged" && state.status !== "Rejected" && state.status !== "On hold" && state.status !== "Retired" || item.value == "goLiveDate" && state.status !== "Live") {
                                return null;
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(item.field_column_size == "Large" ? "col-lg-8 col-md-12" : "col-lg-4 col-md-6", " col-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createBotFirst_module_default()).inputGroup, " "),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item.field_form_field_title,
                                                            item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                children: "*"
                                                            }) : null
                                                        ]
                                                    }),
                                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createBotFirst_module_default()).errorMessage,
                                                        children: "Incorrect Format"
                                                    }) : null : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datetime_cjs_default()), {
                                                closeOnSelect: true,
                                                // initialValue={_.get(state, "dateLogged", [
                                                //   "2020-11-12",
                                                // ])}
                                                closeOnClickOutside: true,
                                                value: state[item.value] && state[item.value] !== "" && state[item.value] !== "undefined" ? convertToDDMMYYYY(state[item.value]) : null,
                                                // initialValue={_get(state, item.value, Date.now())}
                                                timeFormat: false,
                                                dateFormat: "DD-MM-YYYY",
                                                className: "".concat((createBotFirst_module_default()).calender, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (createBotFirst_module_default()).errorBorder : null : null),
                                                inputProps: {
                                                    placeholder: "DD-MM-YYYY",
                                                    readOnly: true,
                                                    disabled: item.value == "dateLogged" || item.value == "dateOfStatusChanged" ? true : false
                                                },
                                                onChange: function(date) {
                                                    return handleDate(date, item.value);
                                                }
                                            })
                                        ]
                                    })
                                });
                            }
                        }
                    })
                })
            }),
            props.pageNum == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(uploadDocuments, {
                sendDocInfo: gotDocInfo,
                editState: state,
                formType: props.formType,
                saveUploadDocumentStateInRedux: gotUploadDocumentsState,
                savedState: props.savedState,
                deleteDemoVideo: deleteDemoVideo,
                sopInvalid: sopInvalid,
                setSopInvalid: setSopInvalid
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (createBotFirst_module_default()).buttonBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (createBotFirst_module_default()).previousBtn,
                            children: props.pageNum != 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (createBotFirst_module_default()).prevBtn,
                                onClick: goBack,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "arrowback",
                                        className: (createBotFirst_module_default()).backarrow
                                    }),
                                    " Previous"
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (createBotFirst_module_default()).combinedBtn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (createBotFirst_module_default()).rowBtn,
                                    onClick: botback,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (createBotFirst_module_default()).exportListBtn,
                                    onClick: botSecond,
                                    children: props.pageNum == 4 ? props.formType == "editBot" ? "Submit" : "Preview Details" : "Save and Proceed"
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader["default"], {}) : null
                    ]
                })
            })
        ]
    });
}
var mapStateToProps = function(state) {
    return {
        currentBot: state.storeBot.currentBot
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var botForm = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(index));


/***/ }),

/***/ 93034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/components/createBotStepper.module.scss
var createBotStepper_module = __webpack_require__(50944);
var createBotStepper_module_default = /*#__PURE__*/__webpack_require__.n(createBotStepper_module);
// EXTERNAL MODULE: ./public/assets/svg/index.jsx + 68 modules
var svg = __webpack_require__(18023);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
// EXTERNAL MODULE: ./components/shared/PlayIcon.jsx
var PlayIcon = __webpack_require__(41708);
// EXTERNAL MODULE: ./node_modules/react-icons/rx/index.esm.js
var rx_index_esm = __webpack_require__(55788);
;// CONCATENATED MODULE: ./components/createBotStepper/CreateBotTutorial.jsx
/* provided dependency */ var process = __webpack_require__(83454);







var CreateBotTutorial = function() {
    var messageText = "Click here to know about new updates";
    var ref = (0,react.useState)(""), message = ref[0], setMessage = ref[1];
    var ref1 = (0,react.useState)(0), index = ref1[0], setIndex = ref1[1];
    var videoUrl = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/instructionvideos/Create_bot_et.mp4?" + process.env.NEXT_PUBLIC_SAS_TOKEN;
    var ref2 = (0,react.useState)(false), showVideo = ref2[0], setShowVideo = ref2[1];
    var videoRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setMessage(messageText.slice(0, index + 1));
            setIndex(function(prev) {
                if (prev === messageText.length) return 0; // restart
                return prev + 1;
            });
        }, 200); // typing speed
        return function() {
            return clearInterval(interval);
        };
    }, [
        index
    ]);
    (0,react.useEffect)(function() {
        if (showVideo) {
            var ref;
            (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        showVideo
    ]);
    var closeVideo = function(e) {
        e.stopPropagation();
        setShowVideo(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute right-2 top-2 text-primary flex items-center gap-2 cursor-default",
                children: [
                    message,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOndemandVideo */.OeP, {
                        onClick: function() {
                            return setShowVideo(true);
                        },
                        className: "!w-8 !h-8 cursor-pointer animate-pulse"
                    })
                ]
            }),
            showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-[9999] fixed left-0 top-0 w-screen h-screen bg-[rgba(0,0,0,0.2)] flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "h-[85%] relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: closeVideo,
                            className: "w-8 h-8 flex justify-center items-center bg-red-500 absolute z-[99999] right-0 top-0 !cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rx_index_esm/* RxCross2 */.$iT, {
                                className: "text-white w-5 h-5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* CustomVideo */.j, {
                            ref: videoRef,
                            src: videoUrl,
                            controls: true,
                            className: "!w-full !h-full"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var createBotStepper_CreateBotTutorial = (CreateBotTutorial);

;// CONCATENATED MODULE: ./components/createBotStepper/index.jsx





function index(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((createBotStepper_module_default()).stepperContainer, " container relative"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(createBotStepper_CreateBotTutorial, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (createBotStepper_module_default()).stepperHeading,
                children: props.editBot == true ? "Edit this Bot" : props.rollout == true ? "Create a Roll Out bot" : "Create a New bot"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (createBotStepper_module_default()).subHeading,
                children: "Enter all details in the form below to create a new bot."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (createBotStepper_module_default()).stepperBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (createBotStepper_module_default()).borderDiv
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (createBotStepper_module_default()).countWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((createBotStepper_module_default()).count, "  ").concat(props.pageNumber > 1 ? (createBotStepper_module_default()).active : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (createBotStepper_module_default()).number,
                                        children: [
                                            " ",
                                            props.pageNumber > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "whitetick"
                                            }) : "1",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (createBotStepper_module_default()).text,
                                        children: " Initial BOT details"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((createBotStepper_module_default()).count, " ").concat(props.pageNumber > 2 ? (createBotStepper_module_default()).active : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (createBotStepper_module_default()).number,
                                        children: props.pageNumber > 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                            name: "whitetick"
                                        }) : "2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (createBotStepper_module_default()).text,
                                        children: " Supporting details"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((createBotStepper_module_default()).count, " ").concat(props.pageNumber > 3 ? (createBotStepper_module_default()).active : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (createBotStepper_module_default()).number,
                                        children: [
                                            " ",
                                            props.pageNumber > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "whitetick"
                                            }) : "3"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (createBotStepper_module_default()).text,
                                        children: " BOT delivery dates"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (createBotStepper_module_default()).count,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (createBotStepper_module_default()).number,
                                        children: "4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (createBotStepper_module_default()).text,
                                        children: "Approval"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 71554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29734);
/* harmony import */ var _styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function index(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState([]), 2), keepTrack = ref[0], setKeepTrack = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        //console.log(props.presentState, "presentState")
        if (props.presentState != null && props.presentState != undefined && props.presentState.length != 0) {
            var previousVStateAr = [];
            props.presentState.map(function(previousItem, index) {
                props.values.map(function(item, index) {
                    //console.log(previousItem, item, "========>itemsspreviousitems")
                    if (previousItem == item) {
                        previousVStateAr.push(index);
                    }
                });
            });
            setKeepTrack((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(previousVStateAr));
        }
    }, []);
    var checkChange = function(option, index, e) {
        // if (option == "No parent Selected")
        //   {
        //     return; 
        //   }
        if (e.target.checked) {
            //console.log(keepTrack, "========>keepTrack", index)
            setKeepTrack((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(keepTrack).concat([
                index
            ]));
            if (props.dropdownParent == "mco") {
                var arr = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props.presentState);
                //console.log("========>mco i",arr)
                arr.push(option);
                //console.log("========>mco im",arr)
                //console.log("========>mco im2",props.presentState)
                props.getDropdownValue(arr, props.dropdownParent, props.haveRelated, true);
            } else {
                var arr1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props.presentState);
                arr1.push(option);
                //console.log("========>mco im",arr)
                //console.log("========>mco im2",props.presentState)
                props.getDropdownValue(option, props.dropdownParent, props.haveRelated, true);
            }
        } else {
            var newKeepTrack = keepTrack.filter(function(item) {
                return item != index;
            });
            setKeepTrack((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(newKeepTrack));
            props.removeCheckedValue(option, props.dropdownParent, props.haveRelated);
        }
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    //console.log(keepTrack, "this is what you ")
    }, [
        keepTrack
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4___default().listContainer),
        children: props.values.map(function(option, index) {
            return(// <li onClick={() => optionSelected(option)}>{option}</li> // give a color on hover , make curson pointer,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4___default().list_Checkbox_container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4___default().lableHead),
                        children: option
                    }),
                    option == "No parent Selected" ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        onChange: function(e) {
                            return checkChange(option, index, e);
                        },
                        checked: keepTrack.includes(index) ? true : false
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_styles_components_listDropdown_module_scss__WEBPACK_IMPORTED_MODULE_4___default().list_checkmark)
                    })
                ]
            }));
        })
    });
}


/***/ }),

/***/ 45336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94363);
/* harmony import */ var _styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function index(props) {
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (props.closeAllDropdowns) {
                        props.closeAllDropdowns();
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    //console.log(props, "dropdownParent")
    var dropRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var optionSelected = function(option) {
        if (option == "No parent Selected") {
            return;
        } else {
            props.getDropdownValue(option, props.dropdownParent, props.haveRelated);
        }
    };
    useOutsideAlerter(dropRef);
    {
        console.log("props.dropdownParent", props.dropdownParent);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: props.params === "approval" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().approvalcontainer) : props.params === "profile" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().profilecontainer) : props.params === "userAccessEdit" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().userAccessEditContainer) : props.params == "demandModal" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().demandModalContainer) : props.params === "demandFilters" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().demandFiltersContainer) : props.params == "botDetailDocument" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().botDetailDocumentContainer) : props.params == "botStoreFilters" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().botStoreFiltersContainer) : props.params == "userAccess" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().userAccessFiltersContainer) : (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listContainer),
        ref: dropRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: props.params === "approval" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listapproval) : props.params === "userAccessEdit" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listUserAccessEdit) : props.params == "demandModal" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listDemandModal) : props.params === "demandFilters" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listDemandFilters) : props.params == "botDetailDocument" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listBotDetailDocument) : props.params == "botStoreFilters" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listBotStoreFilters) : props.params == "userAccess" ? (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listUserAccessFilters) : (_styles_components_listWithoutCheck_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listUlContainer),
            children: props.dropdownParent == "status" || props.dropdownParent == "User type" || props.dropdownParent === "eTProfile" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: props.values.map(function(option, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        style: {
                            backgroundColor: option === "Create new ET Profile" ? "#1f36c7" : "inherit",
                            color: option === "Create new ET Profile" ? "#fff" : "inherit"
                        },
                        onClick: function() {
                            return optionSelected(option);
                        },
                        children: option
                    }) // give a color on hover , make curson pointer,
                    ;
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: props.values.sort().map(function(option, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        onClick: function() {
                            return optionSelected(option);
                        },
                        children: option
                    }) // give a color on hover , make curson pointer,
                    ;
                })
            })
        })
    });
}


/***/ }),

/***/ 41708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ CustomVideo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63750);
/* harmony import */ var react_icons_rx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55788);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15437);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57851);
/* harmony import */ var _hook_useHandleClickOutside__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20288);
/* harmony import */ var _zustand_useProductStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64387);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55678);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5434);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49530);
/* harmony import */ var _lib_store_useSasStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91345);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &::-webkit-media-controls-download-button {\n    display: none;\n  }\n  &::-webkit-media-controls-fullscreen-button {\n    display: none; /* Hide default fullscreen button */\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 50px;\n  width: 100%;\n  text-align: center;\n  color: white;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 5px;\n  font-size: 18px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "Neue Machina Regular";\n  font-size: 13px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 5px;\n  padding: 6px 10px;\n  background-color: rgba(0, 0, 0, 0.2);\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-25876d1d-0"
})(_templateObject());
var PlayIcon = function(param) {
    var _bg = param.bg, bg = _bg === void 0 ? "bg-white" : _bg, _fill = param.fill, fill = _fill === void 0 ? "black" : _fill, _border = param.border, border = _border === void 0 ? "!border-2 !border-black" : _border, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 50 : _iconSize, className = param.className;
    var ref, ref1;
    var ref2 = (0,_hook_useHandleClickOutside__WEBPACK_IMPORTED_MODULE_3__/* .useHandleClickOutside */ .v)(), modalRef = ref2.ref, showVideoModal = ref2.isOpen, setShowVideoModal = ref2.setIsOpen;
    var productDetails = (0,_zustand_useProductStore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().productDetails;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var sasToken = (0,_lib_store_useSasStore__WEBPACK_IMPORTED_MODULE_7__/* .useSas */ .k)().sasToken;
    var captionsUrl = "".concat((ref1 = productDetails === null || productDetails === void 0 ? void 0 : (ref = productDetails.caption) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0], "?").concat(sasToken);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showButton = ref3[0], setShowButton = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), captions = ref4[0], setCaptions = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), currentCaption = ref5[0], setCurrentCaption = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), captionsEnabled = ref6[0], setCaptionsEnabled = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isFullscreen = ref7[0], setIsFullscreen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showLabel = ref8[0], setShowLabel = ref8[1];
    var handleCloseVideoModal = function(e) {
        e.stopPropagation();
        setShowVideoModal(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showVideoModal) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "initial";
        }
        if (videoRef.current) {
            if (showVideoModal) {
                var ref;
                (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
            } else {
                var ref1;
                (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
            }
        }
    }, [
        showVideoModal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (Object.keys(productDetails).length !== 0 && !captionsUrl) {
            react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error("Captions not available for this video");
            return;
        }
        var fetchCaptions = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                var response, text, parsedCaptions, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(captionsUrl)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) throw new Error("Failed to fetch captions");
                            return [
                                4,
                                response.text()
                            ];
                        case 2:
                            text = _state.sent();
                            parsedCaptions = parseVtt(text);
                            console.log("parsedCaptions", parsedCaptions);
                            setCaptions(parsedCaptions);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error fetching captions:", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchCaptions() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchCaptions();
    }, [
        captionsUrl
    ]);
    var parseVtt = function(vttText) {
        var lines = vttText.split(/\r?\n/);
        var captions = [];
        var caption = null;
        for(var i = 0; i < lines.length; i++){
            var line = lines[i].trim();
            if (!line) continue;
            var timeMatch = line.match(/^(\d{2}:\d{2}:\d{2}[\.,]\d{3}) --> (\d{2}:\d{2}:\d{2}[\.,]\d{3})/);
            if (timeMatch) {
                if (caption) captions.push(caption);
                caption = {
                    start: parseTime(timeMatch[1]),
                    end: parseTime(timeMatch[2]),
                    text: ""
                };
            } else if (caption) {
                var cleanedText = line.replace(/<[^>]+>/g, "").trim(); // Remove HTML tags
                cleanedText = cleanedText.replace(/\b[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}-\d+\b/g, ""); // Remove UUID-like strings
                caption.text += (caption.text ? " " : "") + cleanedText.trim();
            }
        }
        // Push the last caption if valid
        if (caption) captions.push(caption);
        return captions;
    };
    // Convert VTT time format (hh:mm:ss,ms) to seconds
    var parseTime = function(timeString) {
        return timeString.replace(",", ".") // Ensure we handle both `,` and `.`
        .split(":").reduce(function(acc, time) {
            return 60 * acc + parseFloat(time);
        }, 0);
    };
    var updateCaptions = function() {
        if (videoRef.current && captions.length > 0) {
            var currentTime = videoRef.current.currentTime;
            var activeCaption = captions.find(function(caption) {
                return currentTime >= caption.start && currentTime <= caption.end;
            });
            setCurrentCaption(activeCaption ? activeCaption.text : "");
        }
    };
    var handleFullScreen = function() {
        setIsFullscreen(!isFullscreen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                className: "".concat(showVideoModal ? "visible opacity-100 " : "invisible opacity-0", " transition-all duration-500 !fixed !z-[999999999999999] left-0 top-0 !w-screen !h-screen !rounded-none bg-black bg-opacity-70 "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    ref: modalRef,
                    className: "bg-white ".concat(isFullscreen ? "w-screen h-screen" : "w-[80vw] h-[86vh]", " flex justify-center items-center mx-auto !rounded-md shadow-lg absolute !z-[999999999999999] top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 transition-all"),
                    onMouseEnter: function() {
                        return setShowButton(true);
                    },
                    onMouseLeave: function() {
                        return setShowButton(false);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "bg-red-500 absolute !right-0 !top-0 p-1 z-10 cursor-pointer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_rx__WEBPACK_IMPORTED_MODULE_11__/* .RxCross2 */ .$iT, {
                                onClick: handleCloseVideoModal,
                                size: 22,
                                color: "#fff"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            onClick: handleFullScreen,
                            onMouseOver: function() {
                                return setShowLabel(true);
                            },
                            onMouseLeave: function() {
                                return setShowLabel(false);
                            },
                            className: "".concat(showButton ? "visible opacity-100" : "invisible opacity-0", " bg-[rgba(0,0,0,0.4)] absolute !left-0 !top-0 p-1 z-10 cursor-pointer"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdFullscreen */ .Nms, {
                                    size: 22,
                                    color: "#fff"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "absolute left-[35px] top-1 whitespace-nowrap bg-[rgba(0,0,0,0.4)] text-white px-2 ".concat(showLabel ? "visible" : "invisible", " transition-all"),
                                    children: isFullscreen ? "Normal Screen View" : "Full Screen View"
                                })
                            ]
                        }),
                        (productDetails === null || productDetails === void 0 ? void 0 : productDetails.video) && (productDetails === null || productDetails === void 0 ? void 0 : productDetails.video) !== "null" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomVideo, {
                                    controlsList: "nodownload",
                                    ref: videoRef,
                                    src: productDetails.video,
                                    controls: true,
                                    className: "!h-full !w-full object-fill",
                                    onTimeUpdate: updateCaptions
                                }),
                                captionsUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        captionsEnabled && currentCaption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Captions, {
                                            children: currentCaption
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                                            className: "".concat(showButton ? "visible opacity-100" : "invisible opacity-0", " transition-all"),
                                            onClick: function() {
                                                return setCaptionsEnabled(!captionsEnabled);
                                            },
                                            children: captionsEnabled ? "Disable Captions [cc]" : "Enable Captions [cc]"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                            className: "font-unilever-shilling-medium",
                            children: "No Video"
                        })
                    ]
                })
            }),
            (productDetails === null || productDetails === void 0 ? void 0 : productDetails.video) && (productDetails === null || productDetails === void 0 ? void 0 : productDetails.video) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                onClick: function(e) {
                    e.stopPropagation();
                    setShowVideoModal(true);
                },
                style: {
                    width: "".concat(iconSize, "px"),
                    height: "".concat(iconSize, "px")
                },
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_13__/* .twMerge */ .m)("p-2 flex justify-center items-center !rounded-full ".concat(bg, " ").concat(border, " absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 ").concat(className)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_14__/* .BsFillPlayFill */ .mz0, {
                    fill: fill,
                    className: "h-full w-full"
                })
            })
        ]
    });
};
var CustomVideo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].video.withConfig */ .ZP.video.withConfig({
    componentId: "sc-25876d1d-1"
})(_templateObject1());
var Captions = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-25876d1d-2"
})(_templateObject2());
var ToggleButton = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-25876d1d-3"
})(_templateObject3());
/* harmony default export */ __webpack_exports__["Z"] = (PlayIcon);


/***/ }),

/***/ 64387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var useProductStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        productDetails: {},
        setProductDetails: function(payload) {
            return set(function(state) {
                return {
                    productDetails: payload
                };
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useProductStore);


/***/ }),

/***/ 67954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60242);
/* harmony import */ var _styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_assets_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18023);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49530);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _listWithoutcheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45336);














function index(props) {
    //console.log(props,"upload props");
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), invalidFile = ref[0], setInvalidFile = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), uploading = ref1[0], setUploading = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), disabled = ref2[0], setDisabled = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), originalFileName = ref3[0], setOriginalFileName = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        docType: ""
    }), 2), state = ref4[0], setState = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        docType: false
    }), 2), dropDownState = ref5[0], setDropdownState = ref5[1];
    var handleDropDown = function(item) {
        setDropdownState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, dropDownState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item, !dropDownState[item])));
    };
    // dropdown value selected
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        if (haveRelated != null && haveRelated.length > 0) {
            var selectedRelatedDropdown = relatedDropdowns[haveRelated];
            selectedRelatedDropdown.nowValues = relatedDropdowns[haveRelated].filter(function(item) {
                return item.field_title == value;
            })[0].field_options;
        }
        setDropdownState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, dropDownState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dropdownParent, false)));
        props.sendDocTypeToParent({
            docType: value
        });
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dropdownParent, value)));
    };
    var handleFileChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(e, title) {
            var fileNameExtension, fileNameExtension1, extensionFlag, i;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                //console.log(props.fileType)
                if (props.type == "demand") {
                    fileNameExtension = e.target.files[0].name.split(".");
                    fileNameExtension = fileNameExtension[fileNameExtension.length - 1];
                    if (props.fileType.includes(fileNameExtension)) {
                        props.uploadFile(e.target.files[0], e.target.name, title, fileNameExtension);
                        setOriginalFileName(e.target.files[0].name);
                        setUploading(true);
                        setInvalidFile(false);
                    } else {
                        setInvalidFile(true);
                    }
                } else {
                    fileNameExtension1 = e.target.files[0].name.split(".");
                    fileNameExtension1 = fileNameExtension1[fileNameExtension1.length - 1];
                    extensionFlag = false;
                    if (typeof props.fileType == "string") {
                        if (props.fileType.includes(fileNameExtension1)) {
                            extensionFlag = true;
                        }
                    } else {
                        for(var i in props.fileType){
                            if (props.fileType[i].includes(fileNameExtension1)) {
                                extensionFlag = true;
                            }
                        }
                    }
                    if (extensionFlag == true) {
                        setOriginalFileName(e.target.files[0].name);
                        //console.log(e.target.files[0], "sd", e.target.name);
                        props.uploadFile(e.target.files[0], e.target.name, title, e.target.files[0].name, fileNameExtension1);
                        if (props.type !== "framework") {
                            setUploading(true);
                        }
                        setInvalidFile(false);
                    } else {
                        setInvalidFile(true);
                    }
                }
                e.target.value = "";
                return [
                    2
                ];
            });
        });
        return function handleFileChange(e, title) {
            return _ref.apply(this, arguments);
        };
    }();
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        //console.log(props.uploaded, "uploadedddddddd")
        if (props.uploaded == true) {
            setUploading(false);
            if (props.type == "createBot") {
                setDisabled(true);
            }
        } else {
            setDisabled(false);
        }
    }, [
        props.uploaded
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (props.originalFileName != null && props.originalFileName.length > 0) {
            //console.log(props.originalFileName, "originalestFileNames");
            setOriginalFileName(props.originalFileName);
        }
    }, [
        props.originalFileName
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (props.currentlyUploading) {
            setDisabled(true);
        } else {
            if (!props.uploaded) {
                setDisabled(false);
            }
        }
    }, [
        props.currentlyUploading
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: disabled == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().disabledInputGroup) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroup),
                children: [
                    props.type == "framework" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdown),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdwoncontain),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mainhandler),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "".concat((_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input)),
                                        onClick: function() {
                                            handleDropDown("docType");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().left),
                                                children: state["docType"] == "" ? "-doc-type-" : state["docType"]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().right),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_svg__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                    name: "chevron",
                                                    className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().chevron)
                                                })
                                            })
                                        ]
                                    }),
                                    dropDownState["docType"] == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().submenu),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_listWithoutcheck__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            dropdownParent: "docType",
                                            values: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(props, "data", []),
                                            getDropdownValue: gotDropDownValue,
                                            haveRelated: null
                                        })
                                    }) : null
                                ]
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uploadButton),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                            for: props.value,
                            children: "Select from device"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "file",
                        style: {
                            display: "none"
                        },
                        id: props.value,
                        onChange: function(e) {
                            handleFileChange(e, props.title);
                        },
                        name: props.value,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat((_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().fileName), " ").concat(props.uploaded == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uploaded) : props.couldNotUpload == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorUploading) : uploading == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uploading) : null),
                        children: props.uploaded == true ? decodeURI(originalFileName) : props.couldNotUpload == true ? "Error while uploading" : uploading == true ? "Uploading..." : " No file chosen"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: props.type == "createBot" && props.value !== "botDemoVideo" && !props.specialCase ? invalidFile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: props.specialCase ? !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsgSpecial) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsgSpecial) : !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsg) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsg),
                    style: {
                        position: "absolute",
                        left: "10px",
                        bottom: "6px"
                    },
                    children: "Incorrect format"
                }) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: props.specialCase ? !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsgSpecial) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsgSpecial) : !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsg) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsg),
                    children: "Upload files in the format of ".concat(typeof props.fileType == "string" || typeof props.fileType == "object" ? props.fileType : ".mov, .avi, .mp4", ".")
                })
            })
        ]
    });
}


/***/ }),

/***/ 64362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ saveCurrentBot; },
/* harmony export */   "uW": function() { return /* binding */ getFilterBotsAction; },
/* harmony export */   "x6": function() { return /* binding */ getBotsAction; }
/* harmony export */ });
/* unused harmony exports getBotsFailed, saveBotsAction, currentBotEditedStateAction */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14138);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49530);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _global_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39471);










var getBotsAction = function(botIndex) {
    // console.log(botIndex, "botindex in action")
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(dispatch) {
            var authCheck, expiryStatus, auth;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            (0,_global_actions__WEBPACK_IMPORTED_MODULE_3__/* .checkExpiry */ .Wr)(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            return [
                                2,
                                axios__WEBPACK_IMPORTED_MODULE_0___default()({
                                    method: "get",
                                    url: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].baseUrl */ .ZP.baseUrl, "/elastic/searchQuery"),
                                    params: {
                                        botIndex: botIndex,
                                        status: "Live"
                                    },
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(response) {
                                    if (response.data.code == 200) {
                                        dispatch(saveBotsAction({
                                            data: response.data.data,
                                            filter: false,
                                            botIndex: botIndex
                                        }));
                                    } else if (response.data.code == 403) {
                                        localStorage.removeItem("auth");
                                        sessionStorage.clear();
                                        // router.push("/login");
                                        dispatch((0,_global_actions__WEBPACK_IMPORTED_MODULE_3__/* .sessionTimeOutCheck */ .Iy)(true));
                                    } else {
                                        dispatch(getBotsFailed());
                                    }
                                })
                            ];
                        } else {
                            dispatch((0,_global_actions__WEBPACK_IMPORTED_MODULE_3__/* .sessionTimeOutCheck */ .Iy)(true));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getFilterBotsAction = function(botIndex, Filters) {
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(dispatch) {
            var authCheck, expiryStatus, auth;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            (0,_global_actions__WEBPACK_IMPORTED_MODULE_3__/* .checkExpiry */ .Wr)(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            return [
                                2,
                                axios__WEBPACK_IMPORTED_MODULE_0___default()({
                                    method: "get",
                                    url: "".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].baseUrl */ .ZP.baseUrl, "/elastic/searchQuery"),
                                    params: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, Filters), {
                                        botIndex: botIndex
                                    }),
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(resp) {
                                    if (resp.data.code == 200) {
                                        dispatch(saveBotsAction({
                                            data: resp.data.data,
                                            filter: true,
                                            botIndex: botIndex
                                        }));
                                    } else if (resp.data.code == 403) {
                                        localStorage.removeItem("auth");
                                        sessionStorage.clear();
                                        // router.push("/login");
                                        dispatch((0,_global_actions__WEBPACK_IMPORTED_MODULE_3__/* .sessionTimeOutCheck */ .Iy)(true));
                                    } else {
                                        dispatch(getBotsFailed());
                                    }
                                })
                            ];
                        } else {
                            dispatch((0,_global_actions__WEBPACK_IMPORTED_MODULE_3__/* .sessionTimeOutCheck */ .Iy)(true));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getBotsFailed = function() {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_8__/* .getBotsFailed */ .$o
    };
};
var saveBotsAction = function(payload) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_8__/* .saveBotsActionType */ .Le,
        payload: payload
    };
};
// to save the bot that user clicked on
var saveCurrentBot = function(payload) {
    console.log("at action");
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_8__/* .saveCurrentBotActionType */ .ZG,
        payload: payload
    };
};
var currentBotEditedStateAction = function(payload) {
    console.log(payload, "currentBotEditedState");
    return {
        type: actionTypes.editCurrentBotActionType,
        payload: payload
    };
};


/***/ }),

/***/ 43484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeleton_box":"skeleton_skeleton_box__pEomF","shimmer":"skeleton_shimmer__X5miL"};

/***/ }),

/***/ 32940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"createBotFirst_liveStatus__soWEP","rejectedStatus":"createBotFirst_rejectedStatus__A5Mhk","retiredStatus":"createBotFirst_retiredStatus__X55j9","onHoldStatus":"createBotFirst_onHoldStatus__ZUi1u","in-ProgressStatus":"createBotFirst_in-ProgressStatus__UW0sb","inProgressStatus":"createBotFirst_inProgressStatus__dhGKO","uATStatus":"createBotFirst_uATStatus__00EDC","initialDemandStatus":"createBotFirst_initialDemandStatus__aLMWI","designFeasibilityStatus":"createBotFirst_designFeasibilityStatus__pln_4","feasibilityStatus":"createBotFirst_feasibilityStatus__0dFJc","designStatus":"createBotFirst_designStatus__Ke1p_","ideasStatus":"createBotFirst_ideasStatus__Objtx","buildStatus":"createBotFirst_buildStatus__YHNjG","mainContain":"createBotFirst_mainContain__iHYRv","first_container":"createBotFirst_first_container__NbXcM","maxWidth":"createBotFirst_maxWidth__ffKhZ","inputGroup":"createBotFirst_inputGroup__Wgt8_","errorMessage":"createBotFirst_errorMessage__YZVk2","multipleItems":"createBotFirst_multipleItems__45PHG","input":"createBotFirst_input__bDvgV","right":"createBotFirst_right__aKjLN","more":"createBotFirst_more__4f8Q8","errorBorder":"createBotFirst_errorBorder__DF48J","fieldFormat":"createBotFirst_fieldFormat__EkuVv","formGroup":"createBotFirst_formGroup__EMMqL","mainLabel":"createBotFirst_mainLabel__HeMTt","mandatoryField":"createBotFirst_mandatoryField____kZI","inputGroupWrapper":"createBotFirst_inputGroupWrapper__FSCh5","radioWrapper":"createBotFirst_radioWrapper__dj70C","subLabel":"createBotFirst_subLabel__PgaO2","radioCheckmark":"createBotFirst_radioCheckmark__WntQo","colSecond":"createBotFirst_colSecond__ixlky","row":"createBotFirst_row__lMvju","buttonBody":"createBotFirst_buttonBody__PDcVp","previousBtn":"createBotFirst_previousBtn__MVLwl","prevBtn":"createBotFirst_prevBtn__GDr8E","backarrow":"createBotFirst_backarrow__Nvg_L","combinedBtn":"createBotFirst_combinedBtn__5oPWu","rowBtn":"createBotFirst_rowBtn__ABiPB","plusIcon":"createBotFirst_plusIcon__PbJ4h","exportListBtn":"createBotFirst_exportListBtn__7XbKA","uploadIcon":"createBotFirst_uploadIcon__JQfvb","colFirst":"createBotFirst_colFirst__02SP7","calender":"createBotFirst_calender___3vWh"};

/***/ }),

/***/ 50944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"createBotStepper_liveStatus__AnDfn","rejectedStatus":"createBotStepper_rejectedStatus__bKtKv","retiredStatus":"createBotStepper_retiredStatus__ZBSvv","onHoldStatus":"createBotStepper_onHoldStatus__tmp_v","in-ProgressStatus":"createBotStepper_in-ProgressStatus__7g68I","inProgressStatus":"createBotStepper_inProgressStatus__d9SU1","uATStatus":"createBotStepper_uATStatus__HWLI0","initialDemandStatus":"createBotStepper_initialDemandStatus__OzkAv","designFeasibilityStatus":"createBotStepper_designFeasibilityStatus__gANJz","feasibilityStatus":"createBotStepper_feasibilityStatus__UMLxM","designStatus":"createBotStepper_designStatus__iyNMU","ideasStatus":"createBotStepper_ideasStatus__oqt6M","buildStatus":"createBotStepper_buildStatus__5QoKF","stepperContainer":"createBotStepper_stepperContainer__UME0I","stepperHeading":"createBotStepper_stepperHeading__hWDYY","subHeading":"createBotStepper_subHeading__XYQoO","stepperBody":"createBotStepper_stepperBody__Mf6hn","borderDiv":"createBotStepper_borderDiv__LE1WI","countWrapper":"createBotStepper_countWrapper__IPOOY","count":"createBotStepper_count___pvBS","active":"createBotStepper_active__GWL9l","number":"createBotStepper_number__i7Nmc","text":"createBotStepper_text__TSGp6"};

/***/ }),

/***/ 38710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"documentUploader_liveStatus__iEdBw","rejectedStatus":"documentUploader_rejectedStatus__BSQ7u","retiredStatus":"documentUploader_retiredStatus__iid7s","onHoldStatus":"documentUploader_onHoldStatus__8kIUL","in-ProgressStatus":"documentUploader_in-ProgressStatus___bK9w","inProgressStatus":"documentUploader_inProgressStatus__KGw45","uATStatus":"documentUploader_uATStatus__OYRro","initialDemandStatus":"documentUploader_initialDemandStatus__wdj0X","designFeasibilityStatus":"documentUploader_designFeasibilityStatus__iV5Jt","feasibilityStatus":"documentUploader_feasibilityStatus__s_K35","designStatus":"documentUploader_designStatus__eGhRQ","ideasStatus":"documentUploader_ideasStatus__AAdI_","buildStatus":"documentUploader_buildStatus__xQMWW","editModalWrapper":"documentUploader_editModalWrapper__eSOgD","modalBox":"documentUploader_modalBox__BN0BA","modalHeader":"documentUploader_modalHeader__fV2ML","content":"documentUploader_content__6td6M","search":"documentUploader_search__HfJsm","searchIcon":"documentUploader_searchIcon__nbZaL","modalBody":"documentUploader_modalBody__XFwAM","formatType":"documentUploader_formatType___x2rg","left":"documentUploader_left__mHdr6","right":"documentUploader_right__sH_2v","icon":"documentUploader_icon__8YHgl","modalFooter":"documentUploader_modalFooter__N04j1","countFilesSelected":"documentUploader_countFilesSelected__3tn8e","combinedBtn":"documentUploader_combinedBtn__NFWcR","rowBtn":"documentUploader_rowBtn__UZdpB","plusIcon":"documentUploader_plusIcon__zoNJP","exportListBtn":"documentUploader_exportListBtn__I7OQc","uploadIcon":"documentUploader_uploadIcon__29jeO"};

/***/ }),

/***/ 29734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"listDropdown_liveStatus__bsWb_","rejectedStatus":"listDropdown_rejectedStatus__t10gN","retiredStatus":"listDropdown_retiredStatus__Os3Af","onHoldStatus":"listDropdown_onHoldStatus__py7ND","in-ProgressStatus":"listDropdown_in-ProgressStatus__ylJTa","inProgressStatus":"listDropdown_inProgressStatus__jsRQC","uATStatus":"listDropdown_uATStatus__ladEA","initialDemandStatus":"listDropdown_initialDemandStatus__Lg6Q9","designFeasibilityStatus":"listDropdown_designFeasibilityStatus__Xh5gF","feasibilityStatus":"listDropdown_feasibilityStatus__GI7SR","designStatus":"listDropdown_designStatus__8za_d","ideasStatus":"listDropdown_ideasStatus__oXi6o","buildStatus":"listDropdown_buildStatus__3em1h","listContainer":"listDropdown_listContainer__Uy2IG","list_Checkbox_container":"listDropdown_list_Checkbox_container__1pT93","lableHead":"listDropdown_lableHead__rsY72","list_checkmark":"listDropdown_list_checkmark__ogS_l"};

/***/ }),

/***/ 94363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"listWithoutCheck_liveStatus__DGJFo","rejectedStatus":"listWithoutCheck_rejectedStatus___qEmn","retiredStatus":"listWithoutCheck_retiredStatus__K7DkO","onHoldStatus":"listWithoutCheck_onHoldStatus__PYQTA","in-ProgressStatus":"listWithoutCheck_in-ProgressStatus__T2rVE","inProgressStatus":"listWithoutCheck_inProgressStatus__bgEpJ","uATStatus":"listWithoutCheck_uATStatus__1rIly","initialDemandStatus":"listWithoutCheck_initialDemandStatus__eaAww","designFeasibilityStatus":"listWithoutCheck_designFeasibilityStatus__IUrLv","feasibilityStatus":"listWithoutCheck_feasibilityStatus__FGTuO","designStatus":"listWithoutCheck_designStatus__MIv7D","ideasStatus":"listWithoutCheck_ideasStatus__a95U9","buildStatus":"listWithoutCheck_buildStatus__MtrJF","listContainer":"listWithoutCheck_listContainer__8Tzwf","listUlContainer":"listWithoutCheck_listUlContainer__9b20l","demandModalContainer":"listWithoutCheck_demandModalContainer__fXZN7","listDemandModal":"listWithoutCheck_listDemandModal__k6dP_","userAccessEditContainer":"listWithoutCheck_userAccessEditContainer__su9s7","listUserAccessEdit":"listWithoutCheck_listUserAccessEdit__Qkxlf","approvalcontainer":"listWithoutCheck_approvalcontainer__bjgw3","listapproval":"listWithoutCheck_listapproval__lv6sN","profilecontainer":"listWithoutCheck_profilecontainer__dGIFx","demandFiltersContainer":"listWithoutCheck_demandFiltersContainer__eRwlp","listDemandFilters":"listWithoutCheck_listDemandFilters__hyrAm","botDetailDocumentContainer":"listWithoutCheck_botDetailDocumentContainer__391kN","listBotDetailDocument":"listWithoutCheck_listBotDetailDocument__RqRt7","botStoreFiltersContainer":"listWithoutCheck_botStoreFiltersContainer__6XybX","listBotStoreFilters":"listWithoutCheck_listBotStoreFilters__4FP15","userAccessFiltersContainer":"listWithoutCheck_userAccessFiltersContainer__rPN9f","listUserAccessFilters":"listWithoutCheck_listUserAccessFilters__4WHlU"};

/***/ }),

/***/ 60242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"uploadFile_liveStatus__AaEEO","rejectedStatus":"uploadFile_rejectedStatus__SC1AB","retiredStatus":"uploadFile_retiredStatus__xSDhf","onHoldStatus":"uploadFile_onHoldStatus__nkjjI","in-ProgressStatus":"uploadFile_in-ProgressStatus__e4OF3","inProgressStatus":"uploadFile_inProgressStatus__5VH4V","uATStatus":"uploadFile_uATStatus__73jPw","initialDemandStatus":"uploadFile_initialDemandStatus__yRipV","designFeasibilityStatus":"uploadFile_designFeasibilityStatus__2VnyB","feasibilityStatus":"uploadFile_feasibilityStatus__dh6o9","designStatus":"uploadFile_designStatus__B_22z","ideasStatus":"uploadFile_ideasStatus__c1nXT","buildStatus":"uploadFile_buildStatus__xvYfe","wrapper":"uploadFile_wrapper__ArjLI","inputGroup":"uploadFile_inputGroup__vI1wb","uploadButton":"uploadFile_uploadButton__B9F_w","fileName":"uploadFile_fileName__qkGkr","uploading":"uploadFile_uploading__W41v2","errorUploading":"uploadFile_errorUploading___9ZDe","dropdown":"uploadFile_dropdown__S_QF4","dropdwoncontain":"uploadFile_dropdwoncontain__kC9jE","input":"uploadFile_input__3Ij_Z","left":"uploadFile_left__knASg","right":"uploadFile_right__0SpQY","mainhandler":"uploadFile_mainhandler__ImKhM","submenu":"uploadFile_submenu__rL4CT","disabledInputGroup":"uploadFile_disabledInputGroup__UiRFp","uploaded":"uploadFile_uploaded__QZiEs","validFormatMsg":"uploadFile_validFormatMsg__WK_MM","invalidFormatMsg":"uploadFile_invalidFormatMsg__m3jXO","validFormatMsgSpecial":"uploadFile_validFormatMsgSpecial__l_2O9","invalidFormatMsgSpecial":"uploadFile_invalidFormatMsgSpecial___qc2A"};

/***/ }),

/***/ 96633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"createBot_liveStatus__IN__T","rejectedStatus":"createBot_rejectedStatus__80V75","retiredStatus":"createBot_retiredStatus__zau0D","onHoldStatus":"createBot_onHoldStatus__TLtz0","in-ProgressStatus":"createBot_in-ProgressStatus__l9TF3","inProgressStatus":"createBot_inProgressStatus__sdR7W","uATStatus":"createBot_uATStatus__ZKTMU","initialDemandStatus":"createBot_initialDemandStatus__qb1bB","designFeasibilityStatus":"createBot_designFeasibilityStatus__Sjvel","feasibilityStatus":"createBot_feasibilityStatus__ZrLe5","designStatus":"createBot_designStatus__7Vir2","ideasStatus":"createBot_ideasStatus__9xtsP","buildStatus":"createBot_buildStatus__qS0Ee"};

/***/ }),

/***/ 5361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"createBotFinal_liveStatus__IWOLR","rejectedStatus":"createBotFinal_rejectedStatus__7_s6w","retiredStatus":"createBotFinal_retiredStatus__lbtJj","onHoldStatus":"createBotFinal_onHoldStatus__aj3pt","in-ProgressStatus":"createBotFinal_in-ProgressStatus__FU6Xo","inProgressStatus":"createBotFinal_inProgressStatus__yhG4M","uATStatus":"createBotFinal_uATStatus__w_cUl","initialDemandStatus":"createBotFinal_initialDemandStatus__uSuF2","designFeasibilityStatus":"createBotFinal_designFeasibilityStatus__ryw05","feasibilityStatus":"createBotFinal_feasibilityStatus__V2J7R","designStatus":"createBotFinal_designStatus__ZbqyT","ideasStatus":"createBotFinal_ideasStatus__7_bk7","buildStatus":"createBotFinal_buildStatus__3At9r"};

/***/ }),

/***/ 59111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"createSecondPage_liveStatus__8Es5U","rejectedStatus":"createSecondPage_rejectedStatus__jU90f","retiredStatus":"createSecondPage_retiredStatus__vRwss","onHoldStatus":"createSecondPage_onHoldStatus__jCVxi","in-ProgressStatus":"createSecondPage_in-ProgressStatus__3ormb","inProgressStatus":"createSecondPage_inProgressStatus__IELx5","uATStatus":"createSecondPage_uATStatus__5bf1n","initialDemandStatus":"createSecondPage_initialDemandStatus__yNxGq","designFeasibilityStatus":"createSecondPage_designFeasibilityStatus__Rk2lf","feasibilityStatus":"createSecondPage_feasibilityStatus__0auyC","designStatus":"createSecondPage_designStatus__C50Hc","ideasStatus":"createSecondPage_ideasStatus__zfWCo","buildStatus":"createSecondPage_buildStatus__LX1Yz","commmonUploader":"createSecondPage_commmonUploader__wZtb_","document":"createSecondPage_document__nS20z","btnUpload":"createSecondPage_btnUpload__7LQrR","text":"createSecondPage_text__45Jko","buttonBody":"createSecondPage_buttonBody__bPN89","previousBtn":"createSecondPage_previousBtn__nvumY","prevBtn":"createSecondPage_prevBtn__9IYab","backarrow":"createSecondPage_backarrow__Hr5pC","combinedBtn":"createSecondPage_combinedBtn__gb_iV","rowBtn":"createSecondPage_rowBtn__fpU1y","plusIcon":"createSecondPage_plusIcon__YdRgk","exportListBtn":"createSecondPage_exportListBtn__V1n8K","uploadIcon":"createSecondPage_uploadIcon__q0U5y"};

/***/ })

}]);